/* Burbuja de Emily para benevolo.shop.
 * Vive en el theme (assets/bv-emily.js) y habla con el servidor de la Colmena por fetch.
 * El chat no va en iframe: ngrok gratis muestra un aviso a los navegadores, que solo se
 * salta con el header ngrok-skip-browser-warning, y eso un iframe no lo puede enviar.
 * Los enlaces de la tienda se vuelven tarjetas con datos reales de Shopify (/products/x.js).
 */
(function () {
  var script = document.currentScript;
  var ENDPOINT = (script && script.dataset.endpoint) || '';
  if (!ENDPOINT || document.getElementById('bv-emily')) return;
  // Avance real de los lotes de Bars.: la plantilla product.bv-progress del theme devuelve el inventario;
  // reservas = meta del lote (100, igual que el hero de preventa) - inventario disponible.
  var LOTE_META = 100;
  var LOTES = [];
  fetch('/products/bars-benevolo?view=bv-progress')
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (p) {
      if (!p) return;
      LOTES = p.variants.map(function (v) {
        return { lote: v.title, reservas: Math.max(0, LOTE_META - Math.max(0, v.inventory)), meta: LOTE_META };
      });
    })
    .catch(function () {});

  var NAVY = '#1A0089', ORANGE = '#FF5E33', CREAM = '#EFE7D3';

  // Emily: mismo diseño que snippets/emily-avatar.liquid de CauaColombia (halo de crespos + gafas),
  // en colores Benévolo: crespos naranja, cara crema, rasgos navy.
  var EMILY_SVG =
    '<svg viewBox="0 0 32 32" aria-hidden="true">' +
    '<g fill="' + ORANGE + '"><circle cx="16" cy="14" r="11.2"/><circle cx="5.5" cy="11.5" r="2.6"/>' +
    '<circle cx="26.5" cy="11.5" r="2.6"/><circle cx="9" cy="5" r="2.4"/><circle cx="23" cy="5" r="2.4"/>' +
    '<circle cx="16" cy="3.2" r="2.7"/><circle cx="6.2" cy="17.5" r="2.4"/><circle cx="25.8" cy="17.5" r="2.4"/></g>' +
    '<ellipse cx="16" cy="18.5" rx="4.6" ry="5.1" fill="' + CREAM + '"/>' +
    '<rect x="14.4" y="22.5" width="3.2" height="3" rx="0.6" fill="' + CREAM + '"/>' +
    '<g stroke="' + NAVY + '" stroke-width="0.85" fill="none"><circle cx="13.8" cy="17.6" r="1.9"/>' +
    '<circle cx="18.2" cy="17.6" r="1.9"/><line x1="15.7" y1="17.6" x2="16.3" y2="17.6"/>' +
    '<line x1="11.9" y1="17.55" x2="11" y2="17.4"/><line x1="20.1" y1="17.55" x2="21" y2="17.4"/></g>' +
    '<circle cx="13.8" cy="17.6" r="0.72" fill="' + NAVY + '"/><circle cx="18.2" cy="17.6" r="0.72" fill="' + NAVY + '"/>' +
    '<path d="M14.3 21.2 Q16 22.2 17.7 21.2" stroke="' + NAVY + '" stroke-width="0.7" stroke-linecap="round" fill="none"/>' +
    '</svg>';

  // Amedeus: Amaury en el mismo lenguaje vectorial (crespos, barba y gafas).
  var AMEDEUS_SVG =
    '<svg viewBox="0 0 32 32" aria-hidden="true">' +
    '<g fill="' + NAVY + '"><circle cx="10" cy="8.5" r="3"/><circle cx="14" cy="6.6" r="3.1"/><circle cx="18.2" cy="6.6" r="3.1"/>' +
    '<circle cx="22.2" cy="8.6" r="3"/><circle cx="8.4" cy="12" r="2.5"/><circle cx="23.8" cy="12" r="2.5"/>' +
    '<circle cx="12" cy="9.8" r="2.6"/><circle cx="20" cy="9.8" r="2.6"/></g>' +
    '<ellipse cx="16" cy="16.6" rx="6.4" ry="7.4" fill="' + CREAM + '"/>' +
    '<rect x="13.8" y="23" width="4.4" height="4" rx="0.8" fill="' + CREAM + '"/>' +
    '<path d="M9.7 16.5 Q9.8 24.6 16 25.6 Q22.2 24.6 22.3 16.5 Q21 21 16 21.4 Q11 21 9.7 16.5Z" fill="' + NAVY + '"/>' +
    '<path d="M13.6 21.3 Q16 22.6 18.4 21.3" stroke="' + CREAM + '" stroke-width="0.8" stroke-linecap="round" fill="none"/>' +
    '<g stroke="' + NAVY + '" stroke-width="0.9" fill="none"><rect x="10.6" y="14.2" width="4.4" height="3.4" rx="1.2"/>' +
    '<rect x="17" y="14.2" width="4.4" height="3.4" rx="1.2"/><line x1="15" y1="15.6" x2="17" y2="15.6"/>' +
    '<line x1="10.6" y1="15.4" x2="9.6" y2="15.1"/><line x1="21.4" y1="15.4" x2="22.4" y2="15.1"/></g>' +
    '<circle cx="12.8" cy="15.9" r="0.7" fill="' + NAVY + '"/><circle cx="19.2" cy="15.9" r="0.7" fill="' + NAVY + '"/>' +
    '</svg>';

  var css = [
    '#bv-emily{position:fixed;right:20px;bottom:20px;z-index:900;font-family:var(--font-ui,"Outfit",system-ui,sans-serif)}',
    '#bv-emily *{box-sizing:border-box}',
    '#bv-emily svg{display:block;width:100%;height:100%}',
    // Lanzador grande: Emily al frente y Amedeus en su insignia, flotando; mientras piensan, Amedeus late.
    '.bve-btn{position:relative;width:84px;height:84px;border-radius:50%;border:2.5px solid ' + CREAM + ';background:' + NAVY + ';cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 10px 30px rgba(26, 0, 137,.4);padding:9px;animation:bveFloat 4s ease-in-out infinite}',
    '.bve-btn:hover{animation-play-state:paused;transform:scale(1.06)}',
    '.bve-btn .bve-am{position:absolute;left:-8px;bottom:-4px;width:38px;height:38px;border-radius:50%;background:' + CREAM + ';border:2px solid ' + NAVY + ';padding:3px;animation:bveOrbit 4s ease-in-out infinite}',
    '.bve-ring{position:absolute;inset:-7px;border-radius:50%;border:2px solid ' + ORANGE + ';opacity:0;animation:bvePulse 3.2s ease-out infinite}',
    '.bve-dot{position:absolute;top:2px;right:4px;width:16px;height:16px;border-radius:50%;background:' + ORANGE + ';border:2px solid ' + CREAM + '}',
    '@keyframes bveFloat{0%,100%{transform:translateY(0)}50%{transform:translateY(-5px)}}',
    '@keyframes bveOrbit{0%,100%{transform:translate(0,0) rotate(0)}50%{transform:translate(-3px,-4px) rotate(-8deg)}}',
    '@keyframes bvePulse{0%{transform:scale(.92);opacity:.7}80%,100%{transform:scale(1.25);opacity:0}}',
    '@keyframes bveThink{0%,100%{transform:scale(1)}50%{transform:scale(1.18)}}',
    '@keyframes bveSlide{from{transform:translateX(24px);opacity:0}to{transform:none;opacity:1}}',
    // Panel lateral derecho de alto completo (sección de conversación), no una burbuja flotante.
    '.bve-panel{position:fixed;right:0;top:0;bottom:0;width:420px;max-width:100vw;background:' + CREAM + ';box-shadow:-18px 0 50px rgba(26, 0, 137,.35);display:none;flex-direction:column;overflow:hidden;border-left:1px solid rgba(26, 0, 137,.12);padding-top:env(safe-area-inset-top,0px);padding-bottom:env(safe-area-inset-bottom,0px)}',
    '#bv-emily.is-open .bve-panel{display:flex;animation:bveSlide .3s ease}',
    '#bv-emily.is-open .bve-btn{display:none}',
    '.bve-duo{position:relative;width:58px;height:46px;flex:none}',
    '.bve-duo .bve-face{position:absolute;left:0;top:0;width:46px;height:46px}',
    '.bve-duo .bve-face2{position:absolute;left:28px;top:14px;width:32px;height:32px;border-radius:50%;background:' + CREAM + ';border:1.5px solid ' + NAVY + ';padding:2px}',
    '#bv-emily.is-thinking .bve-face2,#bv-emily.is-thinking .bve-btn .bve-am{animation:bveThink .9s ease-in-out infinite}',
    '.bve-live{display:inline-block;width:7px;height:7px;border-radius:50%;background:#5BD08A;margin-right:5px;vertical-align:1px}',
    '.bve-head a{color:' + CREAM + ';font-size:11.5px;opacity:.8}',
    '#bv-emily.is-open .bve-dot{display:none}',
    '.bve-head{background:' + NAVY + ';color:' + CREAM + ';padding:14px 16px;display:flex;align-items:center;gap:12px}',
    '.bve-face{width:38px;height:38px;border-radius:50%;background:' + NAVY + ';border:1.5px solid ' + CREAM + ';padding:3px;flex:none}',
    '.bve-head b{display:block;font-size:15px;font-weight:700}',
    '.bve-head small{display:block;font-size:12px;opacity:.75}',
    '.bve-close{margin-left:auto;background:none;border:0;color:' + CREAM + ';font-size:22px;line-height:1;cursor:pointer;padding:4px 6px}',
    '.bve-log{flex:1;overflow-y:auto;padding:16px;display:flex;flex-direction:column;gap:10px}',
    '.bve-msg{max-width:85%;padding:10px 13px;border-radius:14px;font-size:14px;line-height:1.45;white-space:pre-wrap;word-wrap:break-word}',
    '.bve-bot{align-self:flex-start;background:#fff;color:' + NAVY + ';border-bottom-left-radius:4px}',
    '.bve-user{align-self:flex-end;background:' + ORANGE + ';color:#fff;border-bottom-right-radius:4px}',
    '.bve-wait{opacity:.6;font-style:italic}',
    '.bve-by{display:flex;align-items:center;gap:6px;font-size:11px;color:#4A3F8C;margin:-4px 0 0 2px}',
    '.bve-by span{width:20px;height:20px;border-radius:50%;background:' + CREAM + ';border:1px solid ' + NAVY + ';padding:1px;display:inline-block}',
    '.bve-cards{display:flex;flex-direction:column;gap:8px;max-width:92%}',
    '.bve-card{display:flex;gap:10px;background:#fff;border:1px solid rgba(26, 0, 137,.12);border-radius:14px;padding:8px;align-items:center}',
    '.bve-card img{width:64px;height:64px;border-radius:10px;object-fit:cover;flex:none;background:' + CREAM + '}',
    '.bve-card-body{flex:1;min-width:0}',
    '.bve-card a.bve-title{display:block;color:' + NAVY + ';font-weight:700;font-size:13.5px;line-height:1.25;text-decoration:none}',
    '.bve-price{color:' + ORANGE + ';font-weight:700;font-size:13px;margin:2px 0 6px}',
    '.bve-chips{display:flex;flex-wrap:wrap;gap:4px;margin-bottom:6px}',
    '.bve-chip{border:1px solid rgba(26, 0, 137,.25);background:#fff;color:' + NAVY + ';border-radius:999px;font:inherit;font-size:11px;padding:3px 8px;cursor:pointer}',
    '.bve-chip.is-on{background:' + NAVY + ';color:' + CREAM + ';border-color:' + NAVY + '}',
    '.bve-add{border:0;border-radius:999px;background:' + ORANGE + ';color:#fff;font:inherit;font-weight:600;font-size:12.5px;padding:6px 12px;cursor:pointer}',
    '.bve-add:disabled{opacity:.6;cursor:default}',
    '.bve-gocart{margin-left:8px;font-size:12px;color:' + NAVY + ';font-weight:600}',
    '.bve-quick{display:flex;flex-wrap:wrap;gap:6px;align-self:flex-start;max-width:95%}',
    '.bve-q{border:1.5px solid ' + ORANGE + ';background:#fff;color:' + ORANGE + ';border-radius:999px;padding:7px 12px;font:inherit;font-size:13px;font-weight:600;cursor:pointer;transition:all .15s}',
    '.bve-q:hover,.bve-q:focus{background:' + ORANGE + ';color:#fff;outline:none}',
    '.bve-q::after{content:" →"}',
    '.bve-next{display:flex;align-items:center;justify-content:space-between;gap:10px;margin:0 12px;padding:14px 18px;border:0;border-radius:14px;background:' + ORANGE + ';color:#fff;font:inherit;font-weight:800;font-size:16px;cursor:pointer;box-shadow:0 6px 18px rgba(227,58,16,.35)}',
    '.bve-next[hidden]{display:none}',
    '.bve-next.is-done{background:' + NAVY + ';box-shadow:none}',
    '.bve-next.is-buy{background:' + ORANGE + ';box-shadow:0 6px 18px rgba(227,58,16,.35)}',
    '.bve-next-a{font-size:22px;line-height:1;animation:bveNudge 1.4s ease-in-out infinite}',
    '@keyframes bveNudge{0%,100%{transform:translateX(0)}50%{transform:translateX(5px)}}',
    '.bve-step{display:flex;align-items:center;gap:8px;align-self:stretch;font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#4A3F8C}',
    '.bve-step .bve-bar{flex:1;margin:0}',
    '.bve-bar{height:6px;background:rgba(26, 0, 137,.1);border-radius:999px;overflow:hidden;margin-top:4px}',
    '.bve-bar i{display:block;height:100%;background:' + ORANGE + ';border-radius:inherit;transition:width .5s ease}',
    '.bve-reward{align-self:stretch;background:' + NAVY + ';color:' + CREAM + ';border-radius:14px;padding:12px 14px;font-size:13px;line-height:1.4;animation:bveIn .4s ease}',
    '.bve-reward b{display:block;color:' + ORANGE + ';font-size:15px;margin-bottom:2px}',
    '.bve-lote{margin:4px 0 8px}',
    '.bve-lote small{display:flex;justify-content:space-between;gap:8px;font-size:11px;color:#4A3F8C}',
    '.bve-teaser{position:absolute;right:100px;bottom:14px;width:240px;background:#fff;color:' + NAVY + ';border-radius:14px 14px 4px 14px;padding:10px 28px 10px 12px;font-size:13px;line-height:1.35;box-shadow:0 10px 30px rgba(26, 0, 137,.25);cursor:pointer;animation:bveIn .35s ease}',
    '.bve-teaser button{position:absolute;top:2px;right:4px;border:0;background:none;font-size:17px;line-height:1;color:#4A3F8C;cursor:pointer;padding:4px}',
    '#bv-emily.is-open .bve-teaser{display:none}',
    '.bve-vote{align-self:stretch;background:#fff;border:1px solid rgba(26, 0, 137,.12);border-radius:14px;padding:12px;display:grid;gap:10px;animation:bveIn .35s ease}',
    '.bve-vote h4{margin:0;font-size:13px;color:' + NAVY + '}',
    '.bve-vrow{display:grid;grid-template-columns:1fr auto;gap:4px 10px;align-items:center}',
    '.bve-vrow b{font-size:13px;color:' + NAVY + '}',
    '.bve-vrow small{font-size:11px;color:#4A3F8C;grid-column:1}',
    '.bve-vrow .bve-bar{grid-column:1;margin:0}',
    '.bve-vbtn{grid-row:1/span 3;grid-column:2;border:1.5px solid ' + ORANGE + ';background:#fff;color:' + ORANGE + ';border-radius:999px;font:inherit;font-size:12px;font-weight:700;padding:6px 12px;cursor:pointer}',
    '.bve-vbtn.is-mine{background:' + ORANGE + ';color:#fff}',
    '.bve-tarot{align-self:center;perspective:900px;margin:4px 0}',
    '.bve-tcard{position:relative;width:150px;height:230px;transform-style:preserve-3d;transition:transform 1.1s cubic-bezier(.2,.7,.2,1)}',
    '.bve-tcard.is-flipped{transform:rotateY(180deg)}',
    '.bve-tface{position:absolute;inset:0;border-radius:14px;backface-visibility:hidden;-webkit-backface-visibility:hidden;background:' + NAVY + ';border:1.5px solid #B7CF4F;box-shadow:0 12px 28px rgba(26, 0, 137,.35);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;padding:14px;text-align:center;color:' + CREAM + '}',
    '.bve-tback{background:radial-gradient(circle at 50% 40%,#2A14A0,' + NAVY + ')}',
    '.bve-tback svg{width:70%!important;height:auto!important;opacity:.55}',
    '.bve-tfront{transform:rotateY(180deg)}',
    '.bve-tfront small{font-family:var(--bv-serif,"Roboto Serif",Georgia,serif);font-weight:700;font-size:14px;color:#B7CF4F;letter-spacing:.1em}',
    '.bve-tfront i{width:64px;height:64px;display:block}',
    '.bve-tfront b{font-family:var(--bv-serif,"Roboto Serif",Georgia,serif);font-weight:800;font-size:17px;line-height:1.1}',
    '.bve-tfront p{margin:0;font-size:11.5px;line-height:1.35;opacity:.85}',
    '.bve-breath{align-self:stretch;background:#fff;border-radius:14px;padding:12px;display:flex;flex-direction:column;align-items:center;gap:8px;text-align:center;color:' + NAVY + ';animation:bveIn .35s ease}',
    '.bve-breath p{margin:0;font-size:13px;line-height:1.4}',
    '.bve-orb{width:120px;height:120px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:radial-gradient(circle,' + ORANGE + ' 0,' + ORANGE + ' 40%,rgba(227,58,16,.15) 41%);transform:scale(.55);transition:transform 5s ease-in-out}',
    '.bve-orb.is-in{transform:scale(1)}',
    '.bve-orb b{color:#fff;font-size:15px;letter-spacing:.04em}',
    '.bve-breath small{font-size:11px;color:#4A3F8C}',
    '.bve-skip{border:0;background:none;color:#4A3F8C;font:inherit;font-size:12px;text-decoration:underline;cursor:pointer}',
    '.bve-lesson{align-self:stretch;background:#fff;border:1px solid rgba(26, 0, 137,.12);border-radius:14px;padding:12px 14px;color:' + NAVY + ';animation:bveIn .35s ease}',
    '.bve-lhead{display:flex;gap:10px;align-items:center;margin-bottom:6px}',
    '.bve-lhead i{width:40px;height:40px;border-radius:50%;background:' + NAVY + ';padding:6px;flex:none;display:block}',
    '.bve-lhead small{display:block;font-size:10.5px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:' + ORANGE + '}',
    '.bve-lhead b{display:block;font-family:var(--bv-serif,"Roboto Serif",Georgia,serif);font-weight:800;font-size:16px;line-height:1.15}',
    '.bve-lesson p{margin:6px 0;font-size:13px;line-height:1.5}',
    '.bve-lpract{font-weight:600}',
    '.bve-lsrc{display:block;font-size:10.5px;color:#4A3F8C;margin:6px 0}',
    '@media (prefers-reduced-motion:reduce){.bve-tcard,.bve-orb{transition:none}}',
    '.bve-reserve{align-self:stretch;background:#fff;border:2px solid ' + ORANGE + ';border-radius:14px;padding:12px 14px;display:grid;gap:8px;color:' + NAVY + ';animation:bveIn .35s ease}',
    '.bve-reserve b{font-size:15px}',
    '.bve-reserve p{margin:0;font-size:13px;line-height:1.45}',
    '.bve-reserve input:not([type]){border:1px solid rgba(26, 0, 137,.25);border-radius:10px;padding:10px 12px;font:inherit;font-size:16px;color:' + NAVY + '}',
    '.bve-check{display:flex;gap:8px;align-items:flex-start;font-size:12.5px;line-height:1.35}',
    '.bve-legal{font-size:11px;color:#4A3F8C}',
    '.bve-cupos{display:block;font-size:11.5px;font-weight:700;color:' + ORANGE + '}',
    '.bve-note{font-size:11px;color:#4A3F8C}',
    '.bve-badge{justify-self:start;background:' + NAVY + ';color:' + CREAM + ';font-size:12px;font-weight:800;letter-spacing:.06em;padding:6px 12px;border-radius:999px}',
    '.bve-cascade{align-self:stretch;background:#fff;border:1px solid rgba(26, 0, 137,.12);border-radius:14px;padding:12px;display:grid;gap:8px;color:' + NAVY + ';animation:bveIn .35s ease}',
    '.bve-casc{display:grid;grid-template-columns:auto 1fr auto;gap:8px;align-items:center;font-size:12.5px;padding:7px 9px;border-radius:10px;background:' + CREAM + '}',
    '.bve-casc.is-now{background:' + ORANGE + ';color:#fff}',
    '.bve-casc-date{font-weight:800;white-space:nowrap}',
    '.bve-casc-st{font-size:11px;opacity:.85}',
    '#bv-reserve-sheet{position:fixed;inset:0;z-index:1000;background:rgba(26, 0, 137,.55);display:flex;align-items:flex-end;justify-content:center;font-family:var(--font-ui,"Outfit",system-ui,sans-serif)}',
    '#bv-reserve-sheet *{box-sizing:border-box}',
    '#bv-reserve-sheet [hidden],#bv-emily [hidden]{display:none!important}',
    '.bvr-sheet{position:relative;width:100%;max-width:480px;max-height:92vh;overflow-y:auto;background:' + CREAM + ';color:' + NAVY + ';border-radius:22px 22px 0 0;padding:22px 20px calc(22px + env(safe-area-inset-bottom,0px));animation:bveIn .3s ease}',
    '@media (min-width:600px){#bv-reserve-sheet{align-items:center}.bvr-sheet{border-radius:22px}}',
    '.bvr-x{position:absolute;top:10px;right:12px;width:40px;height:40px;border:0;background:none;font-size:28px;line-height:1;color:' + NAVY + ';cursor:pointer}',
    '.bvr-kicker{margin:0;font-size:12px;font-weight:800;letter-spacing:.14em;text-transform:uppercase;color:' + ORANGE + '}',
    '.bvr-h{margin:4px 0 6px;font-family:var(--bv-serif,"Roboto Serif",Georgia,serif);font-weight:800;font-size:34px;line-height:1.05}',
    '.bvr-count{margin:0 0 14px;font-size:14px;font-weight:700}',
    '.bvr-form{display:grid;gap:12px}',
    '.bvr-field{display:grid;gap:5px;font-size:14px;font-weight:700}',
    '.bvr-field input{width:100%;border:1.5px solid rgba(26, 0, 137,.3);border-radius:12px;padding:14px;font:inherit;font-size:17px;font-weight:400;background:#fff;color:' + NAVY + '}',
    '.bvr-field input:focus{outline:none;border-color:' + ORANGE + '}',
    '.bvr-toggle{display:flex;gap:10px;align-items:flex-start;font-size:14.5px;line-height:1.4;padding:12px;background:#fff;border-radius:12px;cursor:pointer}',
    '.bvr-toggle input{width:22px;height:22px;flex:none;margin:0;accent-color:' + ORANGE + '}',
    '.bvr-legal{font-size:13px;background:none;padding:4px 0}',
    '.bvr-err{margin:0;color:#C2381A;font-weight:700;font-size:14px}',
    '.bvr-lbl{font-size:14px;font-weight:700;margin-bottom:-6px}',
    '.bvr-seg{display:grid;grid-template-columns:1fr 1fr;gap:8px}',
    '.bvr-opt{display:grid;gap:2px;text-align:left;border:1.5px solid rgba(26, 0, 137,.25);background:#fff;border-radius:12px;padding:10px 12px;font:inherit;color:' + NAVY + ';cursor:pointer}',
    '.bvr-opt b{font-size:15px}',
    '.bvr-opt small{font-size:11.5px;color:#4A3F8C}',
    '.bvr-opt.is-on{border-color:' + ORANGE + ';box-shadow:0 0 0 2px ' + ORANGE + ' inset}',
    '.bvr-qty{display:flex;align-items:center;gap:10px;flex-wrap:wrap}',
    '.bvr-qb{width:42px;height:42px;border-radius:50%;border:1.5px solid ' + NAVY + ';background:#fff;font-size:22px;line-height:1;cursor:pointer;color:' + NAVY + '}',
    '.bvr-qv{font-size:22px;min-width:22px;text-align:center}',
    '.bvr-qhint{font-size:13px;font-weight:700;color:' + ORANGE + '}',
    '.bvr-total{margin:0;font-size:14px;font-weight:800}',
    '.bvr-go{width:100%;border:0;border-radius:999px;background:' + ORANGE + ';color:#fff;font:inherit;font-weight:800;font-size:18px;padding:16px;cursor:pointer;margin-top:4px}',
    '.bvr-go:disabled{opacity:.6}',
    '.bvr-fine{margin:0;font-size:12.5px;color:#4A3F8C;text-align:center}',
    '.bvr-badge{display:inline-block;margin:0 0 10px;background:' + NAVY + ';color:' + CREAM + ';font-size:13px;font-weight:800;padding:7px 14px;border-radius:999px}',
    '.bvr-steps{margin:0 0 16px;padding-left:20px;display:grid;gap:6px;font-size:15px;line-height:1.4}',
    '.bvr-link{width:100%;margin-top:10px;border:0;background:none;color:' + ORANGE + ';font:inherit;font-weight:700;font-size:15px;cursor:pointer}',
    '.bve-acct{margin-left:auto;flex:none;white-space:nowrap;border:1.5px solid ' + CREAM + ';background:none;color:' + CREAM + ';border-radius:999px;font:inherit;font-size:12px;font-weight:700;padding:5px 10px;cursor:pointer}',
    '.bve-acct + .bve-close{margin-left:0}',
    '.bve-acctcard{align-self:stretch;background:#fff;border:1px solid rgba(26, 0, 137,.12);border-radius:14px;padding:12px 14px;display:grid;gap:8px;color:' + NAVY + ';animation:bveIn .35s ease}',
    '.bve-acct-h{font-size:16px}',
    '.bve-acctcard p{margin:0;font-size:13px;line-height:1.45}',
    '.bve-acct-row{display:flex;justify-content:space-between;font-size:12.5px}',
    '.bve-acct-link{color:' + ORANGE + ';font-weight:800;font-size:14px}',
    '.bve-acct-form{display:grid;gap:6px}',
    '.bve-acct-form input{border:1px solid rgba(26, 0, 137,.25);border-radius:10px;padding:10px 12px;font:inherit;font-size:16px}',
    '.bve-track{list-style:none;margin:0;padding:0;display:grid;gap:6px;font-size:13px}',
    '.bve-track li{padding-left:22px;position:relative;opacity:.65}',
    '.bve-track li::before{content:"";position:absolute;left:2px;top:3px;width:12px;height:12px;border-radius:50%;border:2px solid ' + NAVY + '}',
    '.bve-track li.is-on{opacity:1;font-weight:800}',
    '.bve-track li.is-on::before{background:' + ORANGE + ';border-color:' + ORANGE + '}',
    '.bve-exp{align-self:stretch;background:#fff;border:2px solid ' + NAVY + ';border-radius:14px;padding:12px 14px;display:grid;gap:8px;color:' + NAVY + ';animation:bveIn .35s ease}',
    '.bve-exp-h{font-family:var(--bv-serif,"Roboto Serif",Georgia,serif);font-weight:800;font-size:19px;line-height:1.15}',
    '.bve-exp p{margin:0;font-size:13px;line-height:1.45}',
    '.bve-exp-list{margin:0;padding-left:18px;font-size:13px;line-height:1.45;display:grid;gap:3px}',
    '.bve-acct-exp{display:grid;gap:6px;padding:10px;border-radius:10px;background:' + CREAM + ';font-size:13px}',
    '@keyframes bveIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}',
    '.bve-form{display:flex;gap:8px;padding:12px;border-top:1px solid rgba(26, 0, 137,.12);background:' + CREAM + '}',
    '.bve-form input{flex:1;border:1px solid rgba(26, 0, 137,.25);border-radius:999px;padding:10px 14px;font:inherit;font-size:14px;color:' + NAVY + ';background:#fff;outline:none}',
    '.bve-form input:focus{border-color:' + ORANGE + '}',
    '.bve-form button{border:0;border-radius:999px;background:' + ORANGE + ';color:#fff;font:inherit;font-weight:600;padding:0 16px;cursor:pointer}',
    '.bve-form button:disabled{opacity:.5;cursor:default}',
    // 16px en el input evita el zoom automático de Safari iOS al enfocar
    '@media (max-width:480px){#bv-emily{right:16px;bottom:16px}.bve-btn{width:72px;height:72px;padding:8px}.bve-btn .bve-am{width:32px;height:32px}.bve-panel{width:100vw}.bve-form input{font-size:16px}.bve-teaser{right:86px;width:200px}}',
    '@media (prefers-reduced-motion:reduce){.bve-btn,.bve-btn .bve-am,.bve-ring,.bve-next-a,#bv-emily.is-thinking .bve-face2{animation:none!important}}'
  ].join('');

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var root = document.createElement('div');
  root.id = 'bv-emily';
  root.innerHTML =
    '<div class="bve-panel" role="dialog" aria-label="Chat con Emily">' +
      '<div class="bve-head"><div class="bve-duo"><div class="bve-face">' + EMILY_SVG + '</div><div class="bve-face2">' + AMEDEUS_SVG + '</div></div>' +
      '<div><b>Emily y Amedeus</b><small><span class="bve-live"></span>Agentes de Chocolate Benévolo · <a href="/pages/agentes">cómo funcionamos</a></small></div>' +
      '<button type="button" class="bve-acct">Mi cuenta</button><button type="button" class="bve-close" aria-label="Cerrar chat">×</button></div>' +
      '<div class="bve-log" aria-live="polite"></div>' +
      '<button type="button" class="bve-next" hidden><span class="bve-next-t"></span><span class="bve-next-a" aria-hidden="true">→</span></button>' +
      '<form class="bve-form"><input type="text" maxlength="500" placeholder="Escríbele a Emily…" aria-label="Mensaje">' +
      '<button type="submit">Enviar</button></form>' +
    '</div>' +
    '<button type="button" class="bve-btn" aria-label="Abrir chat con Emily y Amedeus" aria-expanded="false">' +
      '<span class="bve-ring"></span>' + EMILY_SVG + '<span class="bve-am">' + AMEDEUS_SVG + '</span><span class="bve-dot"></span></button>';
  document.body.appendChild(root);

  var btn = root.querySelector('.bve-btn');
  var log = root.querySelector('.bve-log');
  var form = root.querySelector('.bve-form');
  var input = form.querySelector('input');
  var send = form.querySelector('button');
  var greeted = false;
  // Barra de siguiente paso: siempre muestra la acción principal con flecha, para que la ruta no se pierda en el chat.
  var nextBtn = root.querySelector('.bve-next');
  function reserved() { return store('local', 'bve-reservado') === '1'; }
  function refreshNext() {
    nextBtn.hidden = false;
    var buyUrl = store('local', 'bve-checkout');
    nextBtn.querySelector('.bve-next-t').textContent = buyUrl ? 'Completar mi pedido' : reserved() ? 'Haz tu ritual de hoy' : 'Reserva tu Melo. y paga el 9 de noviembre';
    nextBtn.classList.toggle('is-buy', !!buyUrl);
    nextBtn.classList.toggle('is-done', reserved());
  }
  root.querySelector('.bve-acct').addEventListener('click', function () { add('Mi cuenta', 'user'); showAccount(); });
  nextBtn.addEventListener('click', function () {
    var buyUrl = store('local', 'bve-checkout');
    if (buyUrl) { location.href = buyUrl; return; }
    if (reserved()) { add('Saca tu carta del ritual', 'user'); drawCard(); }
    else startReserve(false, 'barra');
  });
  var history = []; // últimos turnos, para que Emily recuerde la conversación
  var shown = {}; // productos que ya tienen tarjeta en esta conversación
  var STORE_LINK = /https:\/\/benevolo\.shop\/[^\s]*[^\s.,;:!?)]/g;

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text) node.textContent = text;
    return node;
  }

  function scroll() { log.scrollTop = log.scrollHeight; }

  function money(cents) {
    return '$' + Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  // Un enlace de producto da el handle; uno de carrito (/cart/ID:1) se resuelve con /variants/ID,
  // que Shopify redirige a la ficha del producto.
  function resolveLink(url) {
    var u = new URL(url);
    var product = u.pathname.match(/^\/products\/([^/?#]+)/);
    if (product) return Promise.resolve({ handle: product[1], variant: null });
    var cart = u.pathname.match(/^\/cart\/(\d+)/);
    if (!cart) return Promise.resolve(null);
    return fetch('/variants/' + cart[1]).then(function (r) {
      var m = new URL(r.url).pathname.match(/^\/products\/([^/?#]+)/);
      return m ? { handle: m[1], variant: Number(cart[1]) } : null;
    });
  }

  // ── Melo.: lanzamiento 9 de noviembre con reserva sin cobro (90 cupos, 9 termos personalizados) ──
  // Mientras llega la Notificación Sanitaria de Melo. no se cobra: se aparta el cupo con nombre y contacto.
  var MELO_HANDLES = ['melo-250', 'pack-melo-termo'];
  var CUPOS = null;
  function loadCupos() {
    return api('/melo/cupos').then(function (c) { CUPOS = c; return c; }).catch(function () { return null; });
  }
  function cuposLine() {
    if (!CUPOS) return 'Lanzamiento 9 de noviembre · 90 cupos · 9 termos personalizados';
    return 'Quedan ' + CUPOS.melo_restantes + ' de ' + CUPOS.melo_total + ' Melo. y ' + CUPOS.termo_restantes + ' de ' + CUPOS.termo_total + ' termos personalizados';
  }
  // Hoja de reserva directa: un solo paso, sin chat. Emily aparece solo como opción después de reservar.
  function reserveSheet(withTermo, origen) {
    var old = document.getElementById('bv-reserve-sheet');
    if (old) old.remove();
    var wrap = el('div'); wrap.id = 'bv-reserve-sheet';
    var sheet = el('div', 'bvr-sheet'); sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true'); sheet.setAttribute('aria-label', 'Reservar Melo.');
    var close = el('button', 'bvr-x', '×'); close.type = 'button'; close.setAttribute('aria-label', 'Cerrar');
    function shut() { wrap.remove(); document.documentElement.style.overflow = ''; }
    close.addEventListener('click', shut);
    wrap.addEventListener('click', function (e) { if (e.target === wrap) shut(); });
    sheet.appendChild(close);
    var body = el('div', 'bvr-body');
    sheet.appendChild(body);
    wrap.appendChild(sheet);
    document.body.appendChild(wrap);
    document.documentElement.style.overflow = 'hidden';

    function field(label, input) { var l = el('label', 'bvr-field'); l.appendChild(el('span', '', label)); l.appendChild(input); return l; }
    function form() {
      body.innerHTML = '';
      body.appendChild(el('p', 'bvr-kicker', 'Preventa · reservas hoy, pagas el 9 nov'));
      body.appendChild(el('h2', 'bvr-h', 'Aparta tu Melo.'));
      body.appendChild(el('p', 'bvr-count', cuposLine()));
      var f = el('form', 'bvr-form'); f.noValidate = true;
      var name = el('input'); name.autocomplete = 'given-name'; name.maxLength = 60; name.placeholder = 'Ej.: Luz Adriana';
      var contact = el('input'); contact.type = 'tel'; contact.autocomplete = 'tel'; contact.inputMode = 'tel'; contact.maxLength = 80; contact.placeholder = 'Ej.: 310 222 7848';
      var mail = el('input'); mail.type = 'email'; mail.autocomplete = 'email'; mail.maxLength = 80; mail.placeholder = 'tu@correo.com';
      // formato y cantidad (discriminación de precios: 500 g sale más barato por gramo; 3 bolsas → termo de regalo)
      var PRICE = { '250': 33000, '500': 59000 }, PACK = 79000;
      var fmt = '250', qty = withTermo ? 1 : 1;
      var fmtRow = el('div', 'bvr-seg');
      [['250', '250 g · $33.000', 'Bolsa de fondo plano'], ['500', '500 g · $59.000', 'Doypack · mejor precio por gramo']].forEach(function (o) {
        var b = el('button', 'bvr-opt' + (o[0] === fmt ? ' is-on' : '')); b.type = 'button'; b.dataset.f = o[0];
        b.appendChild(el('b', '', o[1])); b.appendChild(el('small', '', o[2]));
        b.addEventListener('click', function () { fmt = o[0]; fmtRow.querySelectorAll('.bvr-opt').forEach(function (x) { x.classList.toggle('is-on', x.dataset.f === fmt); }); sync(); });
        fmtRow.appendChild(b);
      });
      var qtyRow = el('div', 'bvr-qty');
      var minus = el('button', 'bvr-qb', '−'); minus.type = 'button'; minus.setAttribute('aria-label', 'Menos');
      var qv = el('b', 'bvr-qv', '1');
      var plus = el('button', 'bvr-qb', '+'); plus.type = 'button'; plus.setAttribute('aria-label', 'Más');
      var qhint = el('small', 'bvr-qhint', '');
      qtyRow.appendChild(minus); qtyRow.appendChild(qv); qtyRow.appendChild(plus); qtyRow.appendChild(qhint);
      minus.addEventListener('click', function () { qty = Math.max(1, qty - 1); sync(); });
      plus.addEventListener('click', function () { qty = Math.min(6, qty + 1); sync(); });
      var termoRow = el('label', 'bvr-toggle'); var tcb = el('input'); tcb.type = 'checkbox'; tcb.checked = !!withTermo;
      termoRow.appendChild(tcb); termoRow.appendChild(el('span', '', 'Agregar el termo personalizado (pack Melo. 250 g + termo: $79.000)'));
      var tname = el('input'); tname.maxLength = 18; tname.placeholder = 'Ej.: Lucesita';
      var tfield = field('Nombre en el termo', tname);
      var total = el('p', 'bvr-total', '');
      tcb.addEventListener('change', sync);
      function sync() {
        qv.textContent = qty;
        var gift = qty >= 3;
        termoRow.hidden = gift || fmt !== '250' || qty !== 1;
        if (termoRow.hidden) tcb.checked = false;
        var withT = gift || tcb.checked;
        tfield.hidden = !withT;
        qhint.textContent = gift ? 'Termo personalizado de regalo ✓' : 'Con 3 bolsas, el termo va de regalo';
        var t = tcb.checked ? PACK : PRICE[fmt] * qty;
        total.textContent = 'Total estimado: $' + t.toLocaleString('es-CO') + ' + IVA · se paga el 9 de noviembre' + (gift ? ' · termo gratis' : '');
      }
      setTimeout(sync, 0);
      var ok = el('label', 'bvr-toggle bvr-legal'); var acb = el('input'); acb.type = 'checkbox';
      ok.appendChild(acb); ok.appendChild(el('span', '', 'Acepto que Benévolo guarde mis datos para avisarme del lanzamiento.'));
      var err = el('p', 'bvr-err'); err.hidden = true;
      var go = el('button', 'bvr-go', 'Apartar mi Melo.'); go.type = 'submit';
      [field('Tu nombre', name), field('Tu WhatsApp', contact), field('Tu correo (ahí te llega tu enlace de compra)', mail), el('span', 'bvr-lbl', 'Formato'), fmtRow, el('span', 'bvr-lbl', 'Bolsas'), qtyRow, termoRow, tfield, total, ok, err, go].forEach(function (n) { f.appendChild(n); });
      f.appendChild(el('p', 'bvr-fine', 'No pagas nada hoy. El 9 de noviembre te enviamos el enlace para completar tu pedido en benevolo.shop.'));
      body.appendChild(f);
      setTimeout(function () { name.focus(); }, 50);
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var msg = !name.value.trim() ? 'Escribe tu nombre.' : !/\d{7,}/.test(contact.value.replace(/\D/g, '')) ? 'Escribe tu WhatsApp.' : !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail.value.trim()) ? 'Escribe tu correo: por ahí te llega tu enlace de compra.' : !acb.checked ? 'Marca la casilla de aceptación para poder avisarte.' : '';
        if (msg) { err.textContent = msg; err.hidden = false; return; }
        err.hidden = true; go.disabled = true; go.textContent = 'Apartando…';
        api('/melo/reserva', { nombre: name.value, contacto: contact.value, correo: mail.value.trim(), termo: tcb.checked, nombre_termo: tname.value, autorizo: true, origen: (store('session', 'bve-src') ? store('session', 'bve-src') + ':' : '') + (origen || 'hoja'), presentacion: fmt, cantidad: qty })
          .then(function (r) { CUPOS = r; store('local', 'bve-reservado', '1'); if (r.token) store('local', 'bve-reserva-token', r.token); refreshNext(); done(r, name.value.trim().split(' ')[0]); })
          .catch(function () { go.disabled = false; go.textContent = 'Apartar mi Melo.'; err.textContent = 'No pudimos apartarlo. Revisa tu WhatsApp y tu correo e inténtalo de nuevo.'; err.hidden = false; });
      });
    }
    function done(r, first) {
      body.innerHTML = '';
      body.appendChild(el('p', 'bvr-kicker', r.ya_reservado ? 'Ya lo tenías apartado' : 'Reserva lista'));
      body.appendChild(el('h2', 'bvr-h', '¡Listo' + (first ? ', ' + first : '') + '!'));
      if (r.benevolente) body.appendChild(el('div', 'bvr-badge', 'Benevolente #' + r.benevolente + ' de Melo.'));
      body.appendChild(el('p', 'bvr-count', (r.cantidad > 1 ? r.cantidad + ' bolsas' : '1 bolsa') + ' de Melo. ' + (r.presentacion || '250') + ' g apartadas' + (r.termo ? (r.termo_regalo ? ' + termo personalizado de regalo. ' : ' + termo personalizado. ') : '. ') + (r.termo_agotado ? 'Los termos se agotaron, pero tu Melo. sí quedó.' : '')));
      var steps = el('ol', 'bvr-steps');
      ['El 9 de noviembre cierra la preventa.', 'Te enviamos el enlace para completar tu pedido en benevolo.shop.', 'Recibes tu Melo. y empiezas tu ritual.'].forEach(function (t) { steps.appendChild(el('li', '', t)); });
      body.appendChild(steps);
      var okb = el('button', 'bvr-go', 'Listo'); okb.type = 'button'; okb.addEventListener('click', shut);
      var em = el('button', 'bvr-link', 'Mientras tanto, haz tu ritual con Emily →'); em.type = 'button';
      em.addEventListener('click', function () { shut(); toggle(true); add('Saca tu carta del ritual', 'user'); drawCard(); });
      body.appendChild(okb); body.appendChild(em);
    }
    form();
  }

  // Mi cuenta: estado de la reserva (llave privada en este navegador), camino de la Benevolencia y pedidos en Shopify.
  function showAccount() {
    var box = el('div', 'bve-acctcard');
    log.appendChild(box);
    var token = store('local', 'bve-reserva-token');
    function lessons() {
      var st = {}; try { st = JSON.parse(store('local', 'bve-lecciones') || '{}'); } catch (e) {}
      var n = (st.done || []).length;
      var row = el('div', 'bve-acct-row');
      row.appendChild(el('span', '', 'Camino de la Benevolencia'));
      row.appendChild(el('b', '', n + ' de 7 lecciones'));
      var bar = el('div', 'bve-bar'); var fill = el('i'); fill.style.width = Math.round(n / 7 * 100) + '%'; bar.appendChild(fill);
      box.appendChild(row); box.appendChild(bar);
    }
    function links() {
      var a = el('a', 'bve-acct-link', 'Mis pedidos y mis datos →'); a.href = '/account';
      box.appendChild(a);
      box.appendChild(el('small', 'bve-note', '¿Dudas? Escríbele a Emily aquí abajo.'));
      var et = store('local', 'bve-exp-token');
      if (et) api('/experiencias/estado/' + encodeURIComponent(et)).then(function (x) {
        var c = el('div', 'bve-acct-exp');
        c.appendChild(el('b', '', x.codigo + ' · ' + (x.titulo || x.formato)));
        var tl = el('ol', 'bve-track');
        x.estados.forEach(function (s, i) { tl.appendChild(el('li', i <= x.paso ? 'is-on' : '', s)); });
        c.appendChild(tl);
        box.insertBefore(c, box.querySelector('.bve-acct-link'));
        scroll();
      }).catch(function () {});
    }
    function render(r) {
      box.innerHTML = '';
      box.appendChild(el('b', 'bve-acct-h', 'Hola, ' + r.nombre));
      box.appendChild(el('div', 'bvr-badge', 'Benevolente #' + r.benevolente + ' de Melo.'));
      var tl = el('ol', 'bve-track');
      [['Reservado · pagas el 9 nov', true], ['Enlace de compra · 9 nov', false], ['Entrega de tu Melo.', false]].forEach(function (s) {
        var li = el('li', s[1] ? 'is-on' : '', s[0]); tl.appendChild(li);
      });
      box.appendChild(tl);
      box.appendChild(el('p', '', (r.cantidad || 1) + ' × Melo. ' + (r.presentacion || '250 g') + '. ' + (r.termo ? 'Con termo personalizado' + (r.nombre_termo ? ' «' + r.nombre_termo + '»' : '') + '. ' : '') + 'Reservado el ' + r.reservado + '. ' + r.siguiente));
      if (r.checkout_url) {
        store('local', 'bve-checkout', r.checkout_url); refreshNext();
        var buy = el('a', 'bve-add', 'Completar mi pedido →'); buy.href = r.checkout_url;
        box.insertBefore(buy, tl.nextSibling);
      }
      lessons(); links();
      scroll();
    }
    function recover() {
      box.innerHTML = '';
      box.appendChild(el('b', 'bve-acct-h', 'Tu cuenta Benévolo'));
      box.appendChild(el('p', '', '¿Ya apartaste tu Melo. en otro celular? Escribe tu WhatsApp y tu nombre para verla aquí.'));
      var f = el('form', 'bve-acct-form');
      var c = el('input'); c.type = 'tel'; c.placeholder = 'Tu WhatsApp o correo'; c.autocomplete = 'tel';
      var n = el('input'); n.placeholder = 'Tu nombre'; n.autocomplete = 'given-name';
      var b = el('button', 'bve-add', 'Ver mi reserva'); b.type = 'submit';
      var err = el('small', 'bve-note');
      [c, n, b, err].forEach(function (x) { f.appendChild(x); });
      f.addEventListener('submit', function (e) {
        e.preventDefault(); b.disabled = true;
        api('/melo/estado', { contacto: c.value, nombre: n.value }).then(function (r) {
          store('local', 'bve-reserva-token', r.token); store('local', 'bve-reservado', '1'); refreshNext(); render(r);
        }).catch(function () { b.disabled = false; err.textContent = 'No encontramos una reserva con esos datos.'; });
      });
      box.appendChild(f);
      var go = el('button', 'bve-add', 'Aún no: apartar mi Melo. →'); go.type = 'button'; go.style.marginTop = '6px';
      go.addEventListener('click', function () { startReserve(false, 'cuenta'); });
      box.appendChild(go);
      lessons(); links();
      scroll();
    }
    if (token) {
      box.appendChild(el('small', 'bve-note', 'Cargando tu cuenta…'));
      api('/melo/estado/' + encodeURIComponent(token)).then(render).catch(recover);
    } else recover();
    scroll();
  }

  // ── Benévolo Experience de punta a punta en el chat: brief en 4 toques → Amedeus (A2A) propone → solicitud ──
  var EXP_STEPS = [
    { k: 'objetivo', q: '¿Qué quieres lograr?', a: ['Regalo corporativo de Navidad', 'Novena para el equipo', 'Lanzamiento de marca', 'Integración de equipo'] },
    { k: 'personas', q: '¿Para cuántas personas?', a: ['Menos de 30', '30 a 60', '60 a 150', 'Más de 150'] },
    { k: 'fecha', q: '¿Para cuándo?', a: ['Antes del 16 de diciembre', 'En diciembre', 'Enero o después', 'Aún no sé'] },
    { k: 'marca', q: '¿Cómo va tu marca?', a: ['Sticker con tu logo', 'Faja con tu logo', 'Caja completa con tu marca', 'Sin marca'] }
  ];
  function expWizard() {
    var brief = {};
    function ask(i) {
      var st = EXP_STEPS[i];
      var row = el('div', 'bve-step');
      row.appendChild(el('span', '', 'Experiencia ' + (i + 1) + '/4'));
      var bar = el('div', 'bve-bar'); var fill = el('i'); fill.style.width = (i / 4 * 100) + '%'; bar.appendChild(fill); row.appendChild(bar);
      log.appendChild(row);
      setTimeout(function () { fill.style.width = ((i + 1) / 4 * 100) + '%'; }, 60);
      add(st.q, 'bot');
      quick(st.a, function (choice) {
        add(choice, 'user');
        brief[st.k] = choice;
        if (i + 1 < EXP_STEPS.length) ask(i + 1); else design();
      });
    }
    function design() {
      var wait = el('div', 'bve-msg bve-bot bve-wait', 'Amedeus está diseñando tu experiencia…');
      log.appendChild(wait); root.classList.add('is-thinking'); scroll();
      api('/experiencias/propuesta', brief).then(function (d) {
        wait.remove(); root.classList.remove('is-thinking');
        proposal(d.propuesta, d.amedeus);
      }).catch(function () {
        wait.remove(); root.classList.remove('is-thinking');
        add('No alcancé a diseñar la propuesta. ¿Lo intentamos de nuevo?', 'bot');
        quick(['Reintentar'], function () { design(); });
      });
    }
    function proposal(pr, amedeus) {
      var box = el('div', 'bve-exp');
      box.appendChild(el('small', 'bve-cupos', pr.formato_nombre || 'Benévolo Experience'));
      box.appendChild(el('b', 'bve-exp-h', pr.titulo));
      if (pr.por_que) box.appendChild(el('p', '', pr.por_que));
      if (pr.componentes && pr.componentes.length) {
        var ul = el('ul', 'bve-exp-list');
        pr.componentes.forEach(function (c) { ul.appendChild(el('li', '', c)); });
        box.appendChild(ul);
      }
      if (pr.personalizacion) box.appendChild(el('p', '', 'Tu marca: ' + pr.personalizacion));
      box.appendChild(el('small', 'bve-note', 'Precio a la medida: el equipo te envía la cotización formal a tu correo.'));
      var go = el('button', 'bve-add', 'Solicitar cotización formal →'); go.type = 'button';
      go.addEventListener('click', function () { go.remove(); request(pr); });
      box.appendChild(go);
      log.appendChild(box);
      if (amedeus) {
        var by = el('div', 'bve-by'); var face = el('span'); face.innerHTML = AMEDEUS_SVG;
        by.appendChild(face); by.appendChild(document.createTextNode('Propuesta diseñada con Amedeus')); log.appendChild(by);
      }
      quick(['Ajustar mi brief'], function () { add('Ajustar mi brief', 'user'); expWizard(); });
      scroll();
    }
    function request(pr) {
      var f = el('form', 'bve-acct-form bve-exp');
      f.appendChild(el('b', '', '¿A dónde te enviamos la cotización?'));
      var n = el('input'); n.placeholder = 'Tu nombre'; n.autocomplete = 'name';
      var e = el('input'); e.type = 'email'; e.placeholder = 'Correo de trabajo'; e.autocomplete = 'email';
      var c = el('input'); c.placeholder = 'Empresa o institución'; c.autocomplete = 'organization';
      var ok = el('label', 'bve-check bve-legal'); var acb = el('input'); acb.type = 'checkbox';
      ok.appendChild(acb); ok.appendChild(document.createTextNode(' Acepto que Benévolo use estos datos para enviarme la cotización.'));
      var err = el('small', 'bvr-err'); err.hidden = true;
      var b = el('button', 'bve-add', 'Enviar solicitud'); b.type = 'submit';
      [n, e, c, ok, err, b].forEach(function (x) { f.appendChild(x); });
      f.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var m = !n.value.trim() ? 'Escribe tu nombre.' : !/@/.test(e.value) ? 'Escribe un correo válido.' : !acb.checked ? 'Marca la casilla para poder enviarte la cotización.' : '';
        if (m) { err.textContent = m; err.hidden = false; return; }
        b.disabled = true; b.textContent = 'Enviando…';
        api('/experiencias/solicitud', { brief: brief, propuesta: pr, nombre: n.value, empresa: c.value, correo: e.value, autorizo: true })
          .then(function (r) {
            store('local', 'bve-exp-token', r.token);
            f.innerHTML = '';
            f.appendChild(el('b', '', 'Solicitud ' + r.codigo + ' recibida ✓'));
            var tl = el('ol', 'bve-track');
            [['Solicitud recibida', true], ['Cotización formal a tu correo', false], ['Experiencia confirmada', false]].forEach(function (x) { tl.appendChild(el('li', x[1] ? 'is-on' : '', x[0])); });
            f.appendChild(tl);
            f.appendChild(el('p', '', 'Sigue el estado cuando quieras en «Mi cuenta».'));
            quick(['Mi cuenta', 'Reserva tu Melo. y paga el 9 de noviembre'], function (o) { add(o, 'user'); if (o === 'Mi cuenta') showAccount(); else startReserve(false, 'experiencia'); });
            scroll();
          })
          .catch(function () { b.disabled = false; b.textContent = 'Enviar solicitud'; err.textContent = 'No pudimos enviarla. Revisa tu correo e inténtalo de nuevo.'; err.hidden = false; });
      });
      log.appendChild(f); scroll(); n.focus();
    }
    ask(0);
  }

  // Calendario de preventas en cascada (cierran el 9 de cada mes; después de noviembre lo ordena la votación).
  function showCascade() {
    var box = el('div', 'bve-cascade');
    box.appendChild(el('b', '', 'Preventas en cascada · cierran el 9 de cada mes'));
    var list = el('div', 'bve-casc-list', 'Cargando…');
    box.appendChild(list);
    box.appendChild(el('small', 'bve-note', 'Después de noviembre, el orden lo deciden los votos de los Benevolentes y puede cambiar.'));
    log.appendChild(box);
    scroll();
    api('/melo/cascada').then(function (d) {
      list.textContent = '';
      d.cascada.slice(0, 5).forEach(function (f, i) {
        var row = el('div', 'bve-casc' + (i === 0 ? ' is-now' : ''));
        row.appendChild(el('span', 'bve-casc-date', f.fecha.replace('9 de ', '9 ') + ' ' + f.anio));
        row.appendChild(el('span', 'bve-casc-prod', f.productos.join(' + ')));
        row.appendChild(el('span', 'bve-casc-st', i === 0 ? 'Abierta' : 'En votación'));
        list.appendChild(row);
      });
      quick(['Reservar mi Melo.', 'Votar el próximo lanzamiento'], function (o) { add(o, 'user'); if (o === 'Reservar mi Melo.') startReserve(false, 'cascada'); else openVote(); });
      scroll();
    }).catch(function () { list.textContent = 'El calendario no está disponible en este momento.'; });
  }

  function startReserve(withTermo, origen) {
    if (root.classList.contains('is-open')) toggle(false);
    var t = document.querySelector('.bve-teaser'); if (t) t.remove();
    reserveSheet(withTermo, origen);
    loadCupos().then(function () { var c = document.querySelector('#bv-reserve-sheet .bvr-count'); if (c && CUPOS && !document.querySelector('#bv-reserve-sheet .bvr-badge')) c.textContent = cuposLine(); });
  }

  function card(product, variantId) {
    var c = el('div', 'bve-card');
    var link = '/products/' + product.handle;
    var img = el('img');
    img.alt = product.title;
    img.src = product.featured_image ? product.featured_image + (product.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
    c.appendChild(img);

    var body = el('div', 'bve-card-body');
    var title = el('a', 'bve-title', product.title);
    title.href = link;
    body.appendChild(title);

    var variants = product.variants.filter(function (v) { return v.available; });
    var selected = variants.filter(function (v) { return v.id === variantId; })[0] || variants[0];
    var price = el('div', 'bve-price', selected ? money(selected.price) : 'Agotado');
    body.appendChild(price);

    if (variants.length > 1) {
      var chips = el('div', 'bve-chips');
      variants.forEach(function (v) {
        var chip = el('button', 'bve-chip' + (v === selected ? ' is-on' : ''), v.title);
        chip.type = 'button';
        chip.addEventListener('click', function () {
          selected = v;
          price.textContent = money(v.price);
          chips.querySelectorAll('.bve-chip').forEach(function (b) { b.classList.remove('is-on'); });
          chip.classList.add('is-on');
        });
        chips.appendChild(chip);
      });
      body.appendChild(chips);
    }

    if (product.handle === 'bars-benevolo' && LOTES.length) body.appendChild(lotesView());

    if (selected && MELO_HANDLES.indexOf(product.handle) > -1) {
      body.appendChild(el('small', 'bve-cupos', cuposLine()));
      var rsv = el('button', 'bve-add', 'Reservar · pagas el 9 nov');
      rsv.type = 'button';
      rsv.addEventListener('click', function () { startReserve(product.handle === 'pack-melo-termo', 'tarjeta'); });
      body.appendChild(rsv);
    } else if (selected) {
      var add = el('button', 'bve-add', 'Agregar al carrito');
      add.type = 'button';
      add.addEventListener('click', function () {
        add.disabled = true;
        add.textContent = 'Agregando…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: selected.id, quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
          .then(function () {
            add.textContent = 'Agregado ✓';
            if (!body.querySelector('.bve-gocart')) {
              var go = el('a', 'bve-gocart', 'Ir al carrito →');
              go.href = '/cart';
              body.appendChild(go);
            }
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          })
          .catch(function () { add.disabled = false; add.textContent = 'Reintentar'; });
      });
      body.appendChild(add);
    }
    c.appendChild(body);
    return c;
  }

  function addCards(urls, force) {
    if (!urls.length) return;
    var wrap = el('div', 'bve-cards');
    log.appendChild(wrap);
    Promise.all(urls.map(function (u) { return resolveLink(u).catch(function () { return null; }); }))
      .then(function (items) {
        // Una tarjeta por producto; si llegó enlace de carrito, se respeta su variante.
        var byHandle = {};
        items.forEach(function (it) {
          if (it && (!byHandle[it.handle] || it.variant)) byHandle[it.handle] = it;
        });
        var fresh = Object.keys(byHandle).filter(function (h) { return force || !shown[h]; });
        fresh.forEach(function (h) { shown[h] = true; });
        return Promise.all(fresh.slice(0, 3).map(function (h) {
          return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; })
            .then(function (p) { return p && card(p, byHandle[h].variant); })
            .catch(function () { return null; });
        }));
      })
      .then(function (cards) {
        cards.forEach(function (c) { if (c) wrap.appendChild(c); });
        if (!wrap.children.length) wrap.remove();
        scroll();
      });
  }

  // Avance real de cada lote (lo calcula el theme con el inventario de Shopify).
  function lotesView() {
    var box = el('div');
    var total = LOTES.reduce(function (n, l) { return n + l.reservas; }, 0);
    if (!total) {
      // Sin reservas todavía: se dice tal cual, como invitación, sin mostrar barras vacías.
      box.appendChild(el('small', '', 'Los dos lotes están abiertos: ' + LOTES[0].meta + ' cupos cada uno. Tu reserva puede ser de las primeras.'));
      return box;
    }
    LOTES.forEach(function (l) {
      var pct = Math.min(100, Math.round((l.reservas / l.meta) * 100));
      var row = el('div', 'bve-lote');
      var label = el('small');
      label.appendChild(el('span', '', l.lote.split(' · ')[0]));
      label.appendChild(el('span', '', l.reservas + ' de ' + l.meta + ' reservas'));
      var bar = el('div', 'bve-bar');
      var fill = el('i');
      fill.style.width = Math.max(pct, 2) + '%';
      bar.appendChild(fill);
      row.appendChild(label);
      row.appendChild(bar);
      box.appendChild(row);
    });
    return box;
  }

  function quick(options, onPick) {
    var wrap = el('div', 'bve-quick');
    options.forEach(function (o) {
      var b = el('button', 'bve-q', o);
      b.type = 'button';
      b.addEventListener('click', function () { wrap.remove(); onPick(o); });
      wrap.appendChild(b);
    });
    log.appendChild(wrap);
    scroll();
  }

  function store(kind, key, value) {
    try {
      var s = kind === 'local' ? window.localStorage : window.sessionStorage;
      if (value === undefined) return s.getItem(key);
      s.setItem(key, value);
    } catch (e) { return null; }
  }

  // Misión de Descubrimiento: 3 preguntas con botones y una tabla fija que solo usa productos reales.
  var MISSION = [
    { k: 'para', q: '¿Para quién es?', a: ['Para mí', 'Para regalar', 'Para compartir', 'Para cocinar'] },
    { k: 'antojo', q: '¿Qué se te antoja?', a: ['Chocolate con leche', 'Algo con relleno', 'Algo para picar', 'Algo para tomar', 'Me cuido con el azúcar'] },
    { k: 'momento', q: '¿Para qué momento?', a: ['Un antojo de hoy', 'Una fecha especial', 'Quiero probarlo todo'] }
  ];
  var WHY = {
    'bars-benevolo': 'chocolate con leche y marañón colombiano salado, endulzado con alulosa y stevia. Eliges tu lote y tu reserva financia su producción.',
    'bons-cajita-4': 'cuatro bombones con relleno de caramelo salado de alulosa y marañón colombiano: el formato para regalar.',
    'bons-flowpack': 'un bombón con relleno de caramelo salado de alulosa y marañón colombiano, justo para tu antojo.',
    'bites-180': 'pastelitos financier recubiertos de chocolate, en bolsa de 180 g para compartir.',
    'beans-100': 'nibs de cacao recubiertos de chocolate milk y white, en 6 porciones para picar.',
    'cubes-70-1kg': 'cobertura profesional 70% en cubos, para temperar, repostería y chocolatería.',
    'club-benevolo': 'cada mes una caja con un sampling de cada línea y la guía de catación del mes.',
    'melo-250': 'tu ritual de cacao: mezcla en polvo con 48 % cacao de Santander, colágeno y suero de leche para preparar con leche. Cada porción trae 5 g de colágeno hidrolizado y 80 mg de vitamina C. En bolsa de 250 g o de 500 g.'
  };
  function pick(r) {
    if (r.para === 'Para cocinar') return 'cubes-70-1kg';
    if (r.antojo === 'Algo para tomar') return 'melo-250';
    if (r.momento === 'Quiero probarlo todo') return 'club-benevolo';
    if (r.antojo === 'Me cuido con el azúcar') return r.para === 'Para regalar' ? 'bons-cajita-4' : 'bars-benevolo';
    if (r.para === 'Para regalar') return r.antojo === 'Chocolate con leche' ? 'bars-benevolo' : 'bons-cajita-4';
    if (r.para === 'Para compartir') return r.antojo === 'Algo para picar' ? 'beans-100' : 'bites-180';
    if (r.antojo === 'Algo con relleno') return 'bons-flowpack';
    if (r.antojo === 'Algo para picar') return 'beans-100';
    return 'bars-benevolo';
  }

  function startMission() {
    var answers = {};
    function ask(i) {
      var stepRow = el('div', 'bve-step');
      stepRow.appendChild(el('span', '', 'Misión ' + (i + 1) + '/3'));
      var bar = el('div', 'bve-bar');
      var fill = el('i');
      fill.style.width = Math.round((i / 3) * 100) + '%';
      bar.appendChild(fill);
      stepRow.appendChild(bar);
      log.appendChild(stepRow);
      setTimeout(function () { fill.style.width = Math.round(((i + 1) / 3) * 100) + '%'; }, 60);
      add(MISSION[i].q, 'bot');
      quick(MISSION[i].a, function (choice) {
        answers[MISSION[i].k] = choice;
        add(choice, 'user');
        if (i + 1 < MISSION.length) ask(i + 1);
        else reveal(answers);
      });
    }
    ask(0);
  }

  function reveal(answers) {
    var handle = pick(answers);
    var wait = el('div', 'bve-msg bve-bot bve-wait', 'Revelando tu chocolate…');
    log.appendChild(wait);
    scroll();
    setTimeout(function () {
      wait.remove();
      fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
        var text = 'Tu chocolate ideal es ' + p.title + ': ' + WHY[handle];
        add(text + ' https://benevolo.shop/products/' + handle, 'bot', '', true);
        // Emily sigue la conversación sabiendo qué se jugó y qué se recomendó.
        history.push(
          { role: 'user', content: 'Hice la Misión de Descubrimiento: ' + answers.para + ', ' + answers.antojo + ', ' + answers.momento + '.' },
          { role: 'assistant', content: text }
        );
        reward();
        quick(['Reservar mi Melo.', 'Votar el próximo lanzamiento', 'Jugar otra vez'], function (o) {
          if (o === 'Reservar mi Melo.') { add(o, 'user'); startReserve(false, 'mision'); }
          else if (o === 'Votar el próximo lanzamiento') { add(o, 'user'); openVote(); }
          else if (o === 'Jugar otra vez') startMission();
          else input.focus();
        });
      });
    }, 900);
  }

  // Premio: un Bons. individual en el pedido, anotado como atributo del carrito para bodega.
  function reward() {
    var box = el('div', 'bve-reward');
    box.appendChild(el('b', '', '¡Misión cumplida!'));
    var msg = el('span', '', 'Tu pedido lleva un Bons. individual de regalo. Ya quedó anotado en tu carrito.');
    box.appendChild(msg);
    log.appendChild(box);
    scroll();
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Premio Misión': 'Bons. individual de regalo' } })
    }).catch(function () { msg.textContent = 'Tu pedido lleva un Bons. individual de regalo: menciónalo al finalizar la compra.'; });
  }

  // Cocreación: la comunidad vota qué producto base se lanza primero (conteo real del servidor).
  function voterId() {
    var id = store('local', 'bve-voter');
    if (!id) {
      id = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : 'v-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 12);
      store('local', 'bve-voter', id);
    }
    return id;
  }

  function api(path, body) {
    return fetch(ENDPOINT.replace(/\/$/, '') + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': '1' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { if (!r.ok) throw new Error('api'); return r.json(); });
  }

  function voteBoard(data, box) {
    box.textContent = '';
    box.appendChild(el('h4', '', '¿Qué lanzamos primero? Ranking en vivo'));
    var max = Math.max.apply(null, data.ranking.map(function (r) { return r.votos; }).concat([1]));
    data.ranking.forEach(function (r) {
      var row = el('div', 'bve-vrow');
      row.appendChild(el('b', '', r.nombre));
      var mine = data.mi_voto === r.handle;
      var b = el('button', 'bve-vbtn' + (mine ? ' is-mine' : ''), mine ? 'Tu voto ✓' : 'Votar');
      b.type = 'button';
      b.addEventListener('click', function () {
        if (mine) return;
        api('/cocreacion/voto', { voter: voterId(), handle: r.handle }).then(function (d) {
          voteBoard(d, box);
          add('¡Gracias! Tu voto por ' + r.nombre + ' ya cuenta. Votar dice qué quieres; reservar o comprar es lo que financia su lote de 100. https://benevolo.shop/products/' + r.handle, 'bot', '', true);
        }).catch(function () { add('No pude registrar tu voto ahora. Intenta en un minuto.', 'bot'); });
      });
      row.appendChild(b);
      var bar = el('div', 'bve-bar');
      var fill = el('i');
      fill.style.width = Math.max(2, Math.round((r.votos / max) * 100)) + '%';
      bar.appendChild(fill);
      row.appendChild(bar);
      row.appendChild(el('small', '', r.votos + (r.votos === 1 ? ' voto' : ' votos')));
      box.appendChild(row);
    });
  }

  function openVote() {
    add('Benévolo se crea con su comunidad: tú decides qué producto base lanzamos primero. Los sabores de temporada vendrán después, también por votación.', 'bot');
    var box = el('div', 'bve-vote', 'Cargando el ranking…');
    log.appendChild(box);
    scroll();
    api('/cocreacion/ranking?voter=' + encodeURIComponent(voterId()))
      .then(function (d) { voteBoard(d, box); scroll(); })
      .catch(function () { box.textContent = 'La votación no está disponible en este momento.'; });
  }

  // Saludo según la página en la que está el visitante.
  // ── Ritual de cacao: 22 Arcanos de la Benevolencia y 7 lecciones de La Benevolencia ──
  // Contenido curado en ~/amed_llm/knowledge (lo inyecta ui/build_ritual_data.py). Una carta por día por visitante.
  // La pausa de respiración (5 s inhala, 5 s exhala) es una invitación a parar, no un efecto de salud.
  /*RITUAL_DATA*/var RITUAL = {"pausa":{"inhala":5,"exhala":5,"ciclos":7,"texto":"Antes de responder, regálate un minuto. Inhala mientras el círculo crece, exhala mientras se encoge."},"arcanos":[{"n":0,"nombre":"La Semilla","simbolo":"semilla","leccion":1,"sentido":"Todo comienzo es pequeño y no se ve.","pregunta":"¿Qué cosa pequeña que hiciste hoy, nadie más la notó, pero tú sí?"},{"n":1,"nombre":"El Remolino","simbolo":"remolino","leccion":3,"sentido":"El movimiento repetido se vuelve forma.","pregunta":"¿Qué gesto repites cada mañana sin pensarlo, y qué pasaría si lo hicieras a propósito?"},{"n":2,"nombre":"La Mazorca","simbolo":"mazorca","leccion":6,"sentido":"Lo que recibes pasó por muchas manos.","pregunta":"¿Cuántas manos crees que tocaron lo que vas a tomar hoy antes de llegar a ti?"},{"n":3,"nombre":"La Tierra de Santander","simbolo":"montana","leccion":6,"sentido":"Todo origen tiene nombre propio.","pregunta":"¿Qué lugar te enseñó quién eres, aunque ya no vivas ahí?"},{"n":4,"nombre":"La Taza","simbolo":"taza","leccion":3,"sentido":"El recipiente también es parte del ritual.","pregunta":"Si tu mañana fuera una taza, ¿estaría llena, vacía o a medio servir? ¿Por qué?"},{"n":5,"nombre":"El Aliento","simbolo":"aliento","leccion":3,"sentido":"Respirar despacio es la forma más simple de volver.","pregunta":"¿Cuándo fue la última vez que respiraste sin prisa, y qué estabas haciendo?"},{"n":6,"nombre":"El Espejo","simbolo":"espejo","leccion":2,"sentido":"Lo que te dices te va formando.","pregunta":"¿Le hablarías a una amiga como te hablas a ti cuando te equivocas?"},{"n":7,"nombre":"La Mano Abierta","simbolo":"mano","leccion":1,"sentido":"Querer el bien del otro por el otro.","pregunta":"¿A quién le deseas algo bueno hoy sin esperar nada a cambio?"},{"n":8,"nombre":"El Fuego Lento","simbolo":"fuego","leccion":4,"sentido":"Lo valioso se cocina despacio.","pregunta":"¿Qué estás intentando apurar que en realidad necesita su tiempo?"},{"n":9,"nombre":"La Molienda","simbolo":"molino","leccion":4,"sentido":"Transformarse duele un poco y libera aroma.","pregunta":"¿Qué momento difícil terminó sacando algo bueno de ti?"},{"n":10,"nombre":"La Rueda del Lote","simbolo":"rueda","leccion":6,"sentido":"Cien personas sostienen un lote; tú eres una.","pregunta":"¿En qué comunidad eres una de las cien que hacen que algo exista?"},{"n":11,"nombre":"La Medida","simbolo":"balanza","leccion":5,"sentido":"Saber lo que sabemos y lo que no.","pregunta":"¿Qué te prometieron alguna vez que sonaba demasiado bueno para ser verdad?"},{"n":12,"nombre":"La Pausa","simbolo":"pausa","leccion":3,"sentido":"Detenerse también es avanzar.","pregunta":"Si hoy te dieras permiso de parar cinco minutos, ¿qué harías con ellos?"},{"n":13,"nombre":"La Cáscara","simbolo":"cascara","leccion":2,"sentido":"Soltar lo que ya protegió y ya no sirve.","pregunta":"¿Qué hábito te protegió en otra etapa y hoy ya te queda pequeño?"},{"n":14,"nombre":"La Mezcla","simbolo":"mezcla","leccion":7,"sentido":"Lo diverso, bien revuelto, se vuelve uno.","pregunta":"¿Qué partes de tu día parecen no combinar y podrían convivir mejor?"},{"n":15,"nombre":"El Nudo","simbolo":"nudo","leccion":2,"sentido":"Mirar el nudo con calma antes de tirar.","pregunta":"¿Qué te tiene apretado hoy? Si lo nombras en una sola palabra, ¿cuál sería?"},{"n":16,"nombre":"La Lluvia","simbolo":"lluvia","leccion":6,"sentido":"Lo que parece tormenta riega la tierra.","pregunta":"¿Qué te incomodó esta semana que quizá estaba regando algo?"},{"n":17,"nombre":"La Estrella del Cacaotal","simbolo":"estrella","leccion":4,"sentido":"Los antiguos miraban el cielo para sembrar.","pregunta":"¿Qué te orienta cuando no sabes hacia dónde ir?"},{"n":18,"nombre":"La Luna del Tejate","simbolo":"luna","leccion":4,"sentido":"Una bebida compartida sostiene la jornada.","pregunta":"¿Con quién te gustaría compartir una bebida y una conversación sin celular?"},{"n":19,"nombre":"El Sol de la Mañana","simbolo":"sol","leccion":7,"sentido":"Cada mañana es un pequeño comienzo.","pregunta":"Cuando termines tu taza mañana, ¿qué será lo primero que harás con intención?"},{"n":20,"nombre":"El Corazón Atento","simbolo":"corazon","leccion":3,"sentido":"Escuchar el propio ritmo, sin juzgarlo.","pregunta":"Pon la mano en el pecho un momento. ¿Qué notas, sin intentar cambiarlo?"},{"n":21,"nombre":"El Mundo Benévolo","simbolo":"flor","leccion":7,"sentido":"El bien que empieza adentro termina afuera.","pregunta":"Si tu ritual de cacao tuviera un propósito para los demás, ¿cuál sería?"}],"lecciones":[{"id":1,"titulo":"Querer el bien del otro por el otro","simbolo":"mano","cuerpo":["Aristóteles distinguió tres razones para querer a alguien: porque nos es útil, porque nos da placer o porque queremos su bien. Solo la tercera dura. A ese deseo de bien sin cálculo lo llamó eúnoia, benevolencia, y lo puso en la raíz de la amistad verdadera.","La benevolencia no es simpatía ni buena educación. Es una orientación: mirar al otro y preguntarse qué le haría bien, aunque nadie lo vea y aunque no vuelva nada a cambio.","Una marca no puede ser benévola por decreto. Solo puede intentar que cada decisión, desde la finca hasta tu taza, pase por esa misma pregunta."],"fuente":"Aristóteles, Ética a Nicómaco, libros VIII y IX.","pregunta":"¿A quién le deseas hoy algo bueno sin esperar nada a cambio?","practica":"Escribe su nombre en un papel y déjalo junto a tu taza de mañana."},{"id":2,"titulo":"Empieza adentro","simbolo":"espejo","cuerpo":["Es difícil querer el bien de otros mientras uno se trata con dureza. La psicóloga Kristin Neff describió la autocompasión con tres componentes: amabilidad contigo en lugar de juicio, reconocer que equivocarse es parte de la condición humana en lugar de sentirte la única, y mirar lo que sientes con atención, sin exagerarlo ni esconderlo.","Autocompasión no es indulgencia ni excusa. Es la base desde la cual uno se levanta y corrige.","El ritual de cacao es un acto pequeño y concreto de esa amabilidad: preparar algo para ti, a propósito, en lugar de tomarlo de pasada."],"fuente":"Neff, K. (2003). Self-compassion: An alternative conceptualization of a healthy attitude toward oneself. Self and Identity, 2(2), 85-101.","pregunta":"¿Le hablarías a una amiga como te hablas a ti cuando te equivocas?","practica":"Mañana, mientras revuelves tu taza, dite una frase que le dirías a alguien que quieres."},{"id":3,"titulo":"El ritual como ancla","simbolo":"aliento","cuerpo":["Un ritual es una secuencia de gestos que repetimos con intención. Investigaciones en psicología encontraron que realizar rituales, incluso inventados, ayudó a las personas a sentir más control después de una pérdida y a reducir la ansiedad antes de una tarea exigente.","La respiración lenta, alrededor de seis respiraciones por minuto, es la que se usa en las prácticas de coherencia cardíaca que estudia la psicofisiología. Aquí la usamos como una pausa: cinco segundos para inhalar, cinco para exhalar, mientras se calienta la leche.","Seamos precisos: esos efectos se estudiaron en el ritual y en la respiración, no en una bebida. Melo. no los produce. Lo que hace es darte una excusa diaria para detenerte."],"fuente":"Norton, M. I. y Gino, F. (2014). Journal of Experimental Psychology: General, 143(1), 266-272. Brooks, A. W. et al. (2016). Organizational Behavior and Human Decision Processes, 137, 71-85. Lehrer, P. M. y Gevirtz, R. (2014). Frontiers in Psychology, 5, 756. doi:10.3389/fpsyg.2014.00756","pregunta":"¿Cuándo fue la última vez que respiraste sin prisa, y qué estabas haciendo?","practica":"Siete respiraciones lentas antes del primer sorbo. Solo eso."},{"id":4,"titulo":"El tejate: ceremonia y sustento","simbolo":"luna","cuerpo":["En los Valles Centrales de Oaxaca todavía se bebe tejate, una bebida espumosa de maíz y cacao. Un estudio de 2012 analizó muestras de comunidades, mercados urbanos y de un vendedor migrante en California, y recordó que las bebidas de cacao y maíz tienen una historia larga en Mesoamérica: el tejate fue importante en lo ceremonial y también fue alimento básico durante las jornadas duras de trabajo en el campo.","Ceremonia y sustento a la vez. Esa es la forma original de beber cacao. En Chiapas existe otra bebida hermana, el tascalate, también de cacao y maíz.","Melo. no copia ninguna ceremonia. Toma la idea de fondo: el cacao bebido con algo más, al empezar la jornada. Cambia el maíz por suero de leche y suma lo que sabe la tecnología de alimentos de hoy."],"fuente":"Sotelo, A. et al. (2012). Plant Foods for Human Nutrition, 67, 148-155. doi:10.1007/s11130-012-0281-5","pregunta":"¿Con quién te gustaría compartir una bebida y una conversación sin celular?","practica":"Esta semana, toma tu taza una vez acompañada, sin pantallas."},{"id":5,"titulo":"Lo que sabemos y lo que no","simbolo":"balanza","cuerpo":["La benevolencia también es honestidad. Esto es lo que dice la etiqueta, porque lo respalda la formulación: Melo. trae 48 % cacao de Santander, 5 g de colágeno hidrolizado y 80 mg de vitamina C por porción. Decimos qué tiene, nunca qué hace.","Esto es lo que no decimos: que el colágeno de Melo. haga algo por tu piel o tus articulaciones, que te baje el estrés, que equilibre tus hormonas o que rejuvenezca. No hay evidencia suficiente para prometerlo, y preferimos perder una venta que ganarla con una promesa falsa.","Los flavanoles del cacao están en análisis de laboratorio. Cuando tengamos el resultado, te lo contaremos tal cual."],"fuente":"Ficha técnica de Melo. y expediente de evidencia de Chocolate Benévolo (2026).","pregunta":"¿Qué te prometieron alguna vez que sonaba demasiado bueno para ser verdad?","practica":"Lee la etiqueta de un producto que tengas en casa y busca qué promete y qué demuestra."},{"id":6,"titulo":"Hacia afuera: quién lo hace posible","simbolo":"mazorca","cuerpo":["El cacao de Melo. es trinitario, de clones TCS, sembrado en Santander. Lo transforma Chocolate Zurych en Landázuri. Detrás de cada bolsa hay familias que cultivan, fermentan y secan, y un equipo que muele y mezcla.","En Benévolo cada lote es de 100 unidades y lo cofinancia la comunidad: cuando compras, sostienes que el siguiente lote exista. Eres una de las cien manos.","Aquí la benevolencia sale de la taza: saber de dónde viene lo que tomas es una forma de querer el bien de quien lo hizo."],"fuente":"Origen y transformación verificados por Chocolate Benévolo.","pregunta":"¿Cuántas manos crees que tocaron lo que vas a tomar hoy antes de llegar a ti?","practica":"Mañana, antes del primer sorbo, piensa un segundo en esas manos."},{"id":7,"titulo":"Tu práctica: cuando… entonces…","simbolo":"sol","cuerpo":["Las buenas intenciones fallan porque son vagas. El psicólogo Peter Gollwitzer mostró que las intenciones de implementación, planes del tipo «cuando pase X, entonces haré Y», aumentan la probabilidad de cumplir lo que uno se propone.","Tu ritual puede escribirse así: «Cuando ponga a calentar la leche, entonces respiraré siete veces despacio y pensaré en alguien a quien le deseo bien».","Te proponemos siete mañanas. No para cambiar tu vida, sino para comprobar por ti misma o por ti mismo qué pasa cuando te detienes. Si quieres, compártelo con #RitualMelo."],"fuente":"Gollwitzer, P. M. (1999). Implementation intentions: Strong effects of simple plans. American Psychologist, 54(7), 493-503.","pregunta":"Completa la frase: «Cuando ___, entonces ___». ¿Cómo sería la tuya?","practica":"Escribe tu frase y pégala donde preparas tu taza. Siete mañanas."}]};/*FIN_RITUAL_DATA*/
  var expOffered = false;
  var ritualInvited = false; // la invitación a Melo. sale una sola vez por conversación del ritual
  var ritualSeq = 0; // la pausa de una carta vieja no pisa una lección abierta después
  var ritual = null; // {tipo, n} que acompaña cada mensaje mientras dura la conversación del ritual
  var ROMAN = ['0', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII', 'XIII', 'XIV', 'XV', 'XVI', 'XVII', 'XVIII', 'XIX', 'XX', 'XXI'];
  var C = 'stroke="' + CREAM + '" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"';
  var SYM = {
    semilla: '<ellipse cx="20" cy="22" rx="7" ry="10" ' + C + '/><path d="M20 12 Q24 6 29 6" ' + C + '/>',
    remolino: '<path d="M20 20 m0 0 a2 2 0 1 1 3 1 a5 5 0 1 1 -8 -3 a9 9 0 1 1 13 9 a13 13 0 0 1 -18 -2" ' + C + '/>',
    mazorca: '<path d="M20 6 C29 9 30 20 28 26 C26 32 22 35 20 35 C18 35 14 32 12 26 C10 20 11 9 20 6Z" ' + C + '/><path d="M16 9 C14 18 15 28 18 34 M24 9 C26 18 25 28 22 34 M20 6 V35" ' + C + '/>',
    montana: '<path d="M4 32 L15 14 L21 23 L26 16 L36 32 Z" ' + C + '/><circle cx="29" cy="9" r="3" ' + C + '/>',
    taza: '<path d="M9 16 H29 V24 A8 8 0 0 1 21 32 H17 A8 8 0 0 1 9 24 Z" ' + C + '/><path d="M29 18 A4 4 0 0 1 29 26" ' + C + '/><path d="M15 12 Q17 9 15 6 M21 12 Q23 9 21 6" ' + C + '/>',
    aliento: '<path d="M6 16 H24 A4 4 0 1 0 20 12 M6 22 H30 A4 4 0 1 1 26 26 M6 28 H18" ' + C + '/>',
    espejo: '<ellipse cx="20" cy="17" rx="9" ry="11" ' + C + '/><path d="M20 28 V35 M14 35 H26" ' + C + '/><path d="M16 12 Q18 10 20 10" ' + C + '/>',
    mano: '<path d="M12 22 V12 A2 2 0 0 1 16 12 V20 M16 11 V9 A2 2 0 0 1 20 9 V20 M20 10 A2 2 0 0 1 24 10 V20 M24 13 A2 2 0 0 1 28 13 V24 A10 10 0 0 1 18 34 A8 8 0 0 1 10 28 L7 22 A2 2 0 0 1 11 20 L12 22" ' + C + '/>',
    fuego: '<path d="M20 34 C12 34 10 26 14 20 C15 24 18 24 18 21 C18 15 22 12 22 6 C28 12 31 18 29 26 C28 31 24 34 20 34Z" ' + C + '/>',
    molino: '<circle cx="20" cy="20" r="13" ' + C + '/><circle cx="20" cy="20" r="3" ' + C + '/><path d="M20 7 V17 M20 23 V33 M7 20 H17 M23 20 H33" ' + C + '/>',
    rueda: '<circle cx="20" cy="20" r="13" ' + C + '/><circle cx="20" cy="20" r="7" ' + C + '/><path d="M20 7 V13 M20 27 V33 M7 20 H13 M27 20 H33 M11 11 L15 15 M25 25 L29 29 M29 11 L25 15 M11 29 L15 25" ' + C + '/>',
    balanza: '<path d="M20 6 V34 M12 34 H28 M8 12 H32" ' + C + '/><path d="M8 12 L4 22 H12 Z M32 12 L28 22 H36 Z" ' + C + '/>',
    pausa: '<circle cx="20" cy="20" r="14" ' + C + '/><path d="M16 13 V27 M24 13 V27" ' + C + '/>',
    cascara: '<path d="M8 22 A12 12 0 0 1 32 22 Q26 18 20 22 Q14 18 8 22Z" ' + C + '/><path d="M14 28 Q20 34 26 28" ' + C + '/>',
    mezcla: '<circle cx="15" cy="20" r="9" ' + C + '/><circle cx="25" cy="20" r="9" ' + C + '/>',
    nudo: '<path d="M8 20 C8 10 20 10 20 20 C20 30 32 30 32 20 C32 10 20 10 20 20 C20 30 8 30 8 20Z" ' + C + '/>',
    lluvia: '<path d="M10 18 A6 6 0 0 1 16 10 A8 8 0 0 1 30 14 A5 5 0 0 1 30 22 H12 A4 4 0 0 1 10 18Z" ' + C + '/><path d="M14 27 L12 32 M20 27 L18 32 M26 27 L24 32" ' + C + '/>',
    estrella: '<path d="M20 5 L24 16 L35 16 L26 23 L29 34 L20 27 L11 34 L14 23 L5 16 L16 16 Z" ' + C + '/>',
    luna: '<path d="M26 6 A14 14 0 1 0 34 26 A11 11 0 1 1 26 6Z" ' + C + '/>',
    sol: '<circle cx="20" cy="20" r="7" ' + C + '/><path d="M20 4 V9 M20 31 V36 M4 20 H9 M31 20 H36 M9 9 L12 12 M28 28 L31 31 M31 9 L28 12 M9 31 L12 28" ' + C + '/>',
    corazon: '<path d="M20 33 C8 25 5 18 8 12 C11 7 17 8 20 13 C23 8 29 7 32 12 C35 18 32 25 20 33Z" ' + C + '/><path d="M8 21 H14 L16 17 L19 25 L21 20 H32" ' + C + '/>',
    flor: '<circle cx="20" cy="20" r="6" ' + C + '/><circle cx="20" cy="14" r="6" ' + C + '/><circle cx="20" cy="26" r="6" ' + C + '/><circle cx="14.8" cy="17" r="6" ' + C + '/><circle cx="25.2" cy="17" r="6" ' + C + '/><circle cx="14.8" cy="23" r="6" ' + C + '/><circle cx="25.2" cy="23" r="6" ' + C + '/>'
  };
  function sym(key) { return '<svg viewBox="0 0 40 40" aria-hidden="true">' + (SYM[key] || SYM.flor) + '</svg>'; }

  function today() { var d = new Date(); return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(); }
  function sesion() {
    var s = store('session', 'bve-sesion');
    if (!s) { s = voterId().slice(0, 8) + '-' + Date.now().toString(36); store('session', 'bve-sesion', s); }
    return s;
  }

  // Pausa guiada: el círculo crece 5 s (inhala) y se encoge 5 s (exhala), 7 ciclos. Se puede saltar.
  function breathe(done) {
    var cfg = RITUAL.pausa || { inhala: 5, exhala: 5, ciclos: 7, texto: '' };
    var box = el('div', 'bve-breath');
    box.appendChild(el('p', '', cfg.texto));
    var ring = el('div', 'bve-orb');
    var label = el('b', '', 'Inhala');
    ring.appendChild(label);
    box.appendChild(ring);
    var count = el('small', '', '');
    box.appendChild(count);
    var skip = el('button', 'bve-skip', 'Saltar la pausa');
    skip.type = 'button';
    box.appendChild(skip);
    log.appendChild(box);
    scroll();
    var cycle = 0, phase = 0, timer = null, finished = false;
    function step() {
      if (cycle >= cfg.ciclos) return finish();
      var inhale = phase === 0;
      label.textContent = inhale ? 'Inhala' : 'Exhala';
      ring.style.transitionDuration = (inhale ? cfg.inhala : cfg.exhala) + 's';
      ring.classList.toggle('is-in', inhale);
      count.textContent = 'Respiración ' + (cycle + 1) + ' de ' + cfg.ciclos;
      timer = setTimeout(function () { phase = 1 - phase; if (phase === 0) cycle++; step(); }, (inhale ? cfg.inhala : cfg.exhala) * 1000);
    }
    function finish() {
      if (finished) return;
      finished = true;
      clearTimeout(timer);
      skip.remove();
      label.textContent = 'Gracias';
      ring.classList.remove('is-in');
      count.textContent = 'Volviste. Ahora, con calma:';
      done();
    }
    skip.addEventListener('click', finish);
    setTimeout(step, 400);
  }

  function askFromRitual(tipo, n, question) {
    ritual = { tipo: tipo, n: n };
    history = [];
    add(question, 'bot');
    input.placeholder = 'Responde con tus palabras…';
    input.focus();
  }

  function drawCard() {
    var saved = (store('local', 'bve-carta') || '').split('|');
    var again = saved[0] === today();
    var n = again ? Number(saved[1]) : Math.floor(Math.random() * 22);
    var a = (RITUAL.arcanos || [])[n];
    if (!a) return;
    store('local', 'bve-carta', today() + '|' + n);
    if (again) add('Tu carta de hoy ya salió y sigue contigo. Una por día: así cada una tiene su tiempo.', 'bot');
    var wrap = el('div', 'bve-tarot');
    var card = el('div', 'bve-tcard');
    card.innerHTML =
      '<div class="bve-tface bve-tback">' + sym('flor') + '</div>' +
      '<div class="bve-tface bve-tfront"><small>' + ROMAN[n] + '</small><i>' + sym(a.simbolo) + '</i><b></b><p></p></div>';
    card.querySelector('b').textContent = a.nombre; // texto curado, igual se pone como texto
    card.querySelector('p').textContent = a.sentido;
    wrap.appendChild(card);
    log.appendChild(wrap);
    scroll();
    setTimeout(function () { card.classList.add('is-flipped'); }, 500);
    var seq = ++ritualSeq;
    setTimeout(function () {
      if (seq !== ritualSeq) return;
      breathe(function () { if (seq === ritualSeq) askFromRitual('carta', n, a.pregunta); });
    }, again ? 1600 : 3200);
  }

  function lessonState() {
    try { return JSON.parse(store('local', 'bve-lecciones') || '{}'); } catch (e) { return {}; }
  }
  function openLesson(id) {
    var st = lessonState();
    var done = st.done || [];
    var next = Math.min(done.length + 1, 7);
    var unlockedToday = st.last === today();
    if (!id) id = unlockedToday ? done[done.length - 1] || 1 : next;
    if (id > next || (id === next && unlockedToday && done.indexOf(id) < 0)) {
      add('La lección ' + id + ' se abre mañana: una por día, para que cada idea tenga tiempo de asentarse.', 'bot');
      return;
    }
    var l = (RITUAL.lecciones || [])[id - 1];
    if (!l) return;
    if (done.indexOf(id) < 0) { done.push(id); store('local', 'bve-lecciones', JSON.stringify({ done: done, last: today() })); }
    var box = el('div', 'bve-lesson');
    var head = el('div', 'bve-lhead');
    var ico = el('i');
    ico.innerHTML = sym(l.simbolo); // SVG fijo del propio script
    head.appendChild(ico);
    var t = el('div');
    t.appendChild(el('small', '', 'La Benevolencia · lección ' + id + ' de 7'));
    t.appendChild(el('b', '', l.titulo));
    head.appendChild(t);
    box.appendChild(head);
    l.cuerpo.forEach(function (p) { box.appendChild(el('p', '', p)); });
    box.appendChild(el('p', 'bve-lpract', 'Práctica: ' + l.practica));
    box.appendChild(el('small', 'bve-lsrc', l.fuente));
    var bar = el('div', 'bve-bar');
    var fill = el('i');
    fill.style.width = Math.round(done.length / 7 * 100) + '%';
    bar.appendChild(fill);
    box.appendChild(bar);
    var lm = el('button', 'bve-add', 'Vive esta lección con Melo. →');
    lm.type = 'button'; lm.style.marginTop = '6px';
    lm.addEventListener('click', function () { startReserve(false, 'leccion'); });
    box.appendChild(lm);
    if (!/\/pages\/benevolencia/.test(location.pathname)) {
      var more = el('a', 'bve-gocart', 'Ver las 7 lecciones');
      more.href = '/pages/benevolencia';
      box.appendChild(more);
    }
    log.appendChild(box);
    scroll();
    var seq = ++ritualSeq;
    setTimeout(function () { if (seq === ritualSeq) askFromRitual('leccion', id, l.pregunta); }, 900);
  }
  window.bvEmily = {
    open: function () { toggle(true); },
    cuenta: function () { toggle(true); add('Mi cuenta', 'user'); showAccount(); },
    cascada: function () { toggle(true); add('Ver el calendario de preventas', 'user'); showCascade(); },
    votar: function () { toggle(true); add('Votar el próximo lanzamiento', 'user'); openVote(); },
    empresas: function () { toggle(true); add('Armar mi experiencia para empresa', 'user'); expWizard(); },
    reservar: function (termo) { startReserve(!!termo, 'pagina'); },
    carta: function () { toggle(true); add('Saca tu carta del ritual', 'user'); drawCard(); },
    leccion: function (id) { toggle(true); add('Quiero la lección ' + (id || 'de hoy'), 'user'); openLesson(id); }
  };

  function pageContext() {
    var p = location.pathname;
    if (/^\/(pages\/lotes|products\/bars-benevolo)/.test(p)) return { teaser: '¿Quara o La Querencia? Te ayudo a elegir tu lote.', hello: '¿Quara o La Querencia? Te ayudo a elegir tu lote: cada uno tiene 100 cupos y cuando se llena, se cierra.', lotes: true };
    if (/^\/pages\/agentes/.test(p)) return { teaser: '¿Quieres saber cómo pensamos Amedeus y yo?', hello: 'Hola, soy Emily. Amedeus y yo corremos en un computador en Bogotá. Pregúntame lo que quieras sobre cómo funcionamos, o empecemos tu ritual.', ritual: true };
    if (/^\/pages\/ritual/.test(p)) return { teaser: 'Te doy la bienvenida a tu ritual. ¿Sacamos tu carta de hoy?', hello: 'Hola, soy Emily. Te doy la bienvenida a tu ritual de cacao. Mientras preparas tu Melo., ¿sacamos tu carta de hoy o abrimos tu lección?', ritual: true };
    if (/^\/pages\/benevolencia/.test(p)) return { teaser: '¿Abrimos tu lección de hoy de La Benevolencia?', hello: 'Hola, soy Emily. Aquí vive La Benevolencia: siete lecciones cortas, una por día. ¿Abrimos la de hoy o prefieres sacar tu carta del ritual?', ritual: true };
    if (/experiencia/.test(p)) return { teaser: '¿Armamos la experiencia de tu empresa? Son 4 toques.', hello: 'Hola, soy Emily. Armemos la experiencia de tu empresa aquí mismo: 4 preguntas, Amedeus diseña la propuesta y te enviamos la cotización formal a tu correo. ¿Empezamos?', ritual: false };
    if (/club/.test(p)) return { teaser: '¿Te cuento qué trae cada Drop del Club?', hello: 'El Club trae cada mes un sampling de todas las líneas con su guía de catación. ¿Es para ti o para regalar?' };
    if (/^\/products\/(melo-250|pack-melo-termo)/.test(p)) return { teaser: 'Melo. llega el 9 de noviembre. ¿Lo reservas? Pagas el 9 de noviembre.', hello: 'Hola, soy Emily. Melo. es nuestro ritual de cacao de cada mañana y llega el 9 de noviembre. Hoy no cobramos: apartas tu cupo y te avisamos. ¿Lo reservamos de una vez?', melo: true };
    if (/^\/products\//.test(p)) return { teaser: '¿Para quién es este antojo? Te ayudo a decidir.', hello: '¿Es para ti, para regalar o para compartir? Te ayudo a decidir.' };
    if (/^\/cart/.test(p)) return { teaser: '¿Te falta algo para completar tu pedido?', hello: '¿Te falta algo para completar tu pedido? Puedo sugerirte un acompañante.' };
    return { teaser: 'Melo. llega el 9 de noviembre: solo 90 bolsas. ¿La reservas? Pagas el 9 de noviembre.', hello: 'Hola, soy Emily. Nuestro lanzamiento estrella es Melo., un ritual de cacao para tus mañanas: llega el 9 de noviembre, solo 90 bolsas y 9 termos personalizados. Hoy lo reservas y pagas el 9 de noviembre. ¿Te cuento o lo reservamos?', melo: true };
  }
  var CTX = pageContext();

  function add(text, who, agent, force) {
    if (who === 'user') {
      log.appendChild(el('div', 'bve-msg bve-user', text));
      scroll();
      return;
    }
    // Nunca HTML: el texto viene del modelo. Los enlaces de la tienda salen del texto y se vuelven tarjetas.
    var urls = text.match(STORE_LINK) || [];
    var clean = text.replace(STORE_LINK, '').replace(/[ \t]+\n/g, '\n').replace(/\n{2,}/g, '\n').replace(/[ \t]*(aquí|acá|en este enlace)?[ \t]*:[ \t]*(?=¿)/gi, '. ').replace(/[ \t]*(aquí|acá|en este enlace)?[ \t]*:[ \t]*(?=[.?!]|\n|$)/gi, '').replace(/\s+([.,;:!?])/g, '$1').replace(/\.{2,}/g, '.').replace(/ {2,}/g, ' ').trim();
    if (clean && !/[.?!…]$/.test(clean)) clean += '.';
    var msg = el('div', 'bve-msg bve-bot', clean || 'Mira esta opción:');
    log.appendChild(msg);
    if (agent && agent.indexOf('Amedeus') > -1) {
      var by = el('div', 'bve-by');
      var face = el('span');
      face.innerHTML = AMEDEUS_SVG; // SVG fijo del propio script, no contenido externo
      by.appendChild(face);
      by.appendChild(document.createTextNode('Recomendación afinada con Amedeus'));
      log.appendChild(by);
    }
    addCards(urls, force);
    scroll();
    return msg;
  }

  function toggle(open) {
    root.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', String(open));
    if (open) {
      refreshNext();
      if (!greeted) {
        greeted = true;
        add(CTX.hello, 'bot');
        if (CTX.lotes && LOTES.length) {
          var lots = el('div', 'bve-msg bve-bot');
          lots.appendChild(lotesView());
          log.appendChild(lots);
        }
        var opts = CTX.ritual
          ? ['Mi lección de hoy', 'Saca tu carta del ritual', 'Reservar mi Melo.']
          : ['Ver el calendario de preventas', 'Saca tu carta del ritual', 'Jugar la Misión de Descubrimiento', 'Experiencias para empresas'];
        if (CTX.melo) loadCupos().then(function (c) { if (c) add(cuposLine() + '. Todo en Benévolo se lanza por preventa: cada una cierra el 9 de un mes distinto.', 'bot'); });
        quick(opts, function (o) {
          if (o === 'Tengo una pregunta') { input.focus(); return; }
          add(o, 'user');
          if (o === 'Reservar mi Melo.') startReserve(false, 'saludo');
          else if (o === 'Ver el calendario de preventas') showCascade();
          else if (o === 'Experiencias para empresas') expWizard();
          else if (o === 'Saca tu carta del ritual') drawCard();
          else if (o === 'Mi lección de hoy') openLesson();
          else if (o === 'Votar el próximo lanzamiento') openVote(); else startMission();
        });
      }
      input.focus();
    }
  }

  loadCupos();
  (function checkoutReady() {
    var tk = store('local', 'bve-reserva-token');
    if (!tk || new Date() < new Date('2026-11-09T08:00:00-05:00')) return;
    api('/melo/estado/' + encodeURIComponent(tk)).then(function (r) {
      if (r.checkout_url) { store('local', 'bve-checkout', r.checkout_url); refreshNext(); }
    }).catch(function () {});
  })();
  (function deepLink() {
    var q = new URLSearchParams(location.search);
    var src = (q.get('utm_source') || '').replace(/[^\w-]/g, '').slice(0, 14);
    if (src) store('session', 'bve-src', src);  // canal de llegada (instagram, nurture...) para medir reservas por canal
    if (q.has('mision')) setTimeout(function () { toggle(true); add('Jugar la Misión de Descubrimiento', 'user'); startMission(); }, 400);
    else if (q.has('reservar') || q.has('termo')) setTimeout(function () { startReserve(q.has('termo'), 'enlace'); }, 400);
    else if (q.has('armar')) setTimeout(function () { window.bvEmily.empresas(); }, 400);
    else if (q.has('cuenta')) setTimeout(function () { window.bvEmily.cuenta(); }, 400);
    else if (q.has('carta')) setTimeout(function () { window.bvEmily.carta(); }, 400);
    else return;
    store('session', 'bve-teaser', '1');
  })();
  if (!store('session', 'bve-teaser')) {
    setTimeout(function () {
      if (root.classList.contains('is-open')) return;
      store('session', 'bve-teaser', '1');
      var teaser = el('div', 'bve-teaser', CTX.melo && CUPOS ? 'Melo. llega el 9 de noviembre: quedan ' + CUPOS.melo_restantes + ' de 90. ¿Lo reservas? Pagas el 9 de noviembre.' : CTX.teaser);
      var x = el('button', '', '×');
      x.type = 'button';
      x.setAttribute('aria-label', 'Cerrar invitación');
      x.addEventListener('click', function (e) { e.stopPropagation(); teaser.remove(); });
      teaser.appendChild(x);
      teaser.addEventListener('click', function () { teaser.remove(); toggle(true); });
      root.appendChild(teaser);
    }, 6000);
  }

  btn.addEventListener('click', function () { toggle(!root.classList.contains('is-open')); });
  root.querySelector('.bve-close').addEventListener('click', function () { toggle(false); btn.focus(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) toggle(false);
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var text = input.value.trim();
    if (!text) return;
    add(text, 'user');
    input.value = '';
    send.disabled = true;

    var wait = el('div', 'bve-msg bve-bot bve-wait', 'Emily está escribiendo…');
    root.classList.add('is-thinking');
    log.appendChild(wait);
    scroll();
    var ctrl = new AbortController();
    var timer = setTimeout(function () { ctrl.abort(); }, 90000);

    fetch(ENDPOINT.replace(/\/$/, '') + '/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'ngrok-skip-browser-warning': '1' },
      body: JSON.stringify({ prompt: text, user_id: 'benevolo.shop', history: history.slice(-6), ritual: ritual, sesion: ritual ? sesion() : '' }),
      signal: ctrl.signal
    })
      .then(function (r) {
        if (r.status === 429) throw new Error('rate');
        if (!r.ok) throw new Error('http');
        return r.json();
      })
      .then(function (data) {
        var answer = data.answer || 'No alcancé a responder, ¿me lo repites?';
        wait.remove();
        add(answer, 'bot', data.agent);
        if (/empresa|corporativ|novena|evento|regalos|equipo de trabajo|instituci|cataci|taller|lanzamiento de/i.test(text) && !expOffered) {
          expOffered = true;
          quick(['Armar mi experiencia'], function () { add('Armar mi experiencia', 'user'); expWizard(); });
        }
        if (ritual && !ritualInvited && history.filter(function (h) { return h.role === 'user'; }).length >= 2) {
          ritualInvited = true;
          quick(['Vivir mi ritual con Melo.'], function () { add('Quiero vivir mi ritual con Melo.', 'user'); startReserve(false, 'ritual'); });
        }
        history.push({ role: 'user', content: text }, { role: 'assistant', content: answer });
      })
      .catch(function (err) {
        wait.remove();
        add(err.message === 'rate'
          ? 'Vas muy rápido. Dame un minuto y seguimos.'
          : 'Ahora no estoy disponible. Intenta de nuevo en unos minutos.', 'bot');
      })
      .finally(function () {
        root.classList.remove('is-thinking');
        clearTimeout(timer);
        send.disabled = false;
        input.focus();
      });
  });
})();
